import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { AddObjectAttempt_ACTION, GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { CENTER, EAST, FixURL, INGOING_FLOW, NORTH, OUTGOING_FLOW, SOUTH, WEST, SOURCE_FLOW, UNSTEADY_FLOW, CheckKeyboardAnswer, SafeSimplify,combineArrays, checkForDuplicates, GetUniqueValues, GetAnswerCharArray } from '../Services/Utilities';
import ReactCSSTransitionGroup from 'react-transition-group'; // ES6
import Tada from 'react-reveal/Tada';
import SafeLatexViewComponent from './SafeLatexViewComponent';
import LatexViewComponent from './LatexViewComponent';

import Xarrow from "react-xarrows";
import Label from 'reactstrap/lib/Label';
import LineComponent from './LineComponent';
import KatexComponent from './KatexComponent';

var FadingTime;
const NUMERIC_BLOCK = +1
const VARIABLE_BLOCK = +2
class EnergyBalanceQuestionPlayComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
            ShowImageModal: false,
            ShowChartModal: false,
            SelectedImage:{},
            SelectedChart: {},
            AnswersImage: [],
            AnswersChart: [],
            SlidersValues:[0,0,0,0],
            Id: -1,
            RefWidth:0,
            Spy:1,
            QuestionAnswers:[],
            CPAnswers:[],

            SelectedLabels:[],
            ShowPossibleAnswers: [],
            Direction_Names:{
                0:"NORTH",
                2: "SOUTH",
                4:"EAST",
                8: "WEST",
                16:"CENTER",
            },

            CheckAnswer: false,
            DirectionsCheck: [],
            NewBoundryCondition:{
                List:[]
            },
            BoundryConditions:[],
            PossibleEBs:[],
            SelectedLabel:{},
            LinesY:0,
            LinesX:0
        }

        this.SetAnswerModal = this.SetAnswerModal.bind(this)
        this.RelationsModal = this.RelationsModal.bind(this)
        this.AddBoundryConditionModal = this.AddBoundryConditionModal.bind(this)
        this.EditBoundryConditionModal = this.EditBoundryConditionModal.bind(this)


    }

    componentDidMount(){
        this.props.GetQuestion(this.props.Id)

        this.setState({
            Id: this.props.Id
        })

        
/*
        setInterval(() => {
            this.setState({
                Spy: this.state.Spy + 1
            })
        }, 5000)*/
    }

  

    componentWillReceiveProps(nextprops){
        //GET QUESTION DATA
        if(nextprops.Id != this.state.Id){
            this.props.GetQuestion(nextprops.Id)
            this.setState({
                Id: nextprops.Id,
            })
            
            return
        }

        if(nextprops.InSeries && nextprops.Question && nextprops.Id == this.state.Id){

            this.props.Object.setState(prev => ({
                LoadedClickableQuestions:  [...prev.LoadedClickableQuestions, nextprops.Question]
            }))
        
        }


        if(nextprops.Question && nextprops.Question.Id && this.state.Id == nextprops.Question.Id){
            let PossibleEBs = []
            let NRelations = nextprops.Question.ClickableParts[0].Relations
            .filter((r) => !r.EB_QuestionId && r.Direction == NORTH)
            
            let ERelations = nextprops.Question.ClickableParts[0].Relations.
            filter((r) => !r.EB_QuestionId && r.Direction == EAST)
            //.filter((r) => !NRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))

            let SRelations = nextprops.Question.ClickableParts[0].Relations
            .filter((r) => !r.EB_QuestionId && r.Direction == SOUTH)
            //.filter((r) => !NRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            //.filter((r) => !ERelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            
            let WRelations = nextprops.Question.ClickableParts[0].Relations
            .filter((r) => !r.EB_QuestionId && r.Direction == WEST)
            //.filter((r) => !NRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            //.filter((r) => !ERelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            //.filter((r) => !SRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            
            let CRelations = nextprops.Question.ClickableParts[0].Relations
            .filter((r) => !r.EB_QuestionId && r.Direction == CENTER)
            //.filter((r) => !NRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            ////.filter((r) => !ERelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            //.filter((r) => !SRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            //.filter((r) => !WRelations.map((rr) => rr.Label.Id).includes(r.Label.Id))
            
            let TotalArray = []

            if(NRelations.length){
             TotalArray.push(NRelations)
            }

            if(ERelations.length){
             TotalArray.push(ERelations)
            }

            if(SRelations.length){
             TotalArray.push(SRelations)
            }

            if(WRelations.length){
             TotalArray.push(WRelations)
            }

            if(CRelations.length){
             TotalArray.push(CRelations)
            }

            PossibleEBs = combineArrays(TotalArray)


            let TEST = PossibleEBs.map((eb) => [...new Set(eb.map((l) => l.Label.Id))])
            let TEST2 = TEST.map((a) => nextprops.Question.Labels.filter((l) => a.includes(l.Id)))


            PossibleEBs = PossibleEBs.filter((eb) => !checkForDuplicates(eb.map((l) => l.Label.Id)))


            let DPossibleEBs = Array.from(new Set(
                PossibleEBs.map((eb) => eb.map((l) => l.Label.Id).sort((a,b)=> a>b ? 1 : -1))
                
                .map(JSON.stringify)), JSON.parse)

            let FPossibleEBs = DPossibleEBs.map((d) => {
                let x = PossibleEBs.filter((eb) => !eb.filter((l) => !d.includes(l.Label.Id)).length)
                 return x[0]

            })


            this.setState({
                QuestionAnswers: nextprops.Question.Questions.map((q) => ({

                    Id: q.Id,
                    List:[]
                })),

               /* CPAnswers: nextprops.Question.ClickableParts.map((q) => ({
                    List:[]
                }))*/

                PossibleEBs:FPossibleEBs,

                SelectedLabels: [],
                BoundryConditions:[],
                SelectedLabel:{},
                QuestionAnswers:[],
                CPAnswers:[],
                DirectionsCheck: [],
                NewBoundryCondition:{
                    List:[]
                },
                CheckAnswer: false,
            })

            setTimeout(() => {
                var LabelsDiv = ReactDOM.findDOMNode(this.refs['LABELS_DIV'])
                                          .getBoundingClientRect()
                                          
                this.setState({
                    RefHeight: LabelsDiv.height
                })
            }, 1000)
        }
    }
    
    render(){
        console.log(this)
        console.log(GetAnswerCharArray())

        let RefWidth = this.state.RefWidth * 0.9
        let RefHeight = this.state.RefHeight || 0

        let AREAS = []
        if(this.props.Question && this.props.Question.ClickableParts && this.props.Question.ClickableParts.length){
            let ClickableParts = this.props.Question.ClickableParts

            AREAS.push(
                <div 
                key = {1}
                style = {{width:((RefWidth)/this.props.Question.Base_ImageURL_Width)*0.6 * ClickableParts[0].Width, height:((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.20,
                    opacity:this.state.SelectedLabels.filter((sl) => sl.Direction == NORTH).length ? 
                    0.40
                    :0.15,
                    backgroundColor:'green',
                    cursor:'pointer',
                    position:'absolute',
                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].X + 0.2 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Width, 
                    top: RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Y - ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.10,
                }} 
                onClick = {() => {
                    /*let Labels = this.props.Question.Labels

                    this.setState({
                        ShowRelationModal: true,
                        SelectedDirection: NORTH,
                        SelectedCV: ClickableParts[0],
                        ShowQuestions: false,
                        Labels:Labels
                    })*/
                    if(!this.state.SelectedLabel.Id){
                        return
                    }
                    let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = ClickableParts[0].Relations.filter((r) => 
                                      r.LabelId == this.state.SelectedLabel.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                  

                    let New = ({
                        Label: this.state.SelectedLabel,
                        Direction: NORTH,
                        Questions:Questions,
                        FlowType:  INGOING_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    /*for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }*/

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                       SelectedLabel:{}
                    })
                }}
                className = {this.state.SelectedLabel.Id ? "border border-warning" : ""}
                >
                        <div style = {{width:'100%', border:1, borderColor:'green', borderStyle:'solid'}}>

                        </div>
                    </div>
            )

            AREAS.push(
                <div 
                key = {2}
                
                style = {{width:((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.20, border:1, borderColor:'green', borderStyle:'solid',
                            
                            opacity:this.state.SelectedLabels.filter((sl) => sl.Direction == WEST).length ? 
                            0.40
                            :0.15,
                            backgroundColor:'green',
                            cursor:'pointer',
                            position:'absolute',
                            left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*(ClickableParts[0].X - 0.5* ClickableParts[0].Height* 0.20), 
                            top: RefHeight+ ((RefWidth)/this.props.Question.Base_ImageURL_Width)*(ClickableParts[0].Y +0.2 * ClickableParts[0].Height),
                            height:((RefWidth)/this.props.Question.Base_ImageURL_Width)*0.6 * ClickableParts[0].Height
                        }} onClick = {() => {
                            if(!this.state.SelectedLabel.Id){
                                return
                            }

                            let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = ClickableParts[0].Relations.filter((r) => 
                                      r.LabelId == this.state.SelectedLabel.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                    

                    let New = ({
                        Label: this.state.SelectedLabel,
                        Direction: WEST,
                        Questions:Questions,
                        FlowType:  INGOING_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                       SelectedLabel:{}
                    })
                        }}
                        className = {this.state.SelectedLabel.Id ? "border border-warning" : ""}

                        >

                                </div>
            )

            AREAS.push(
                <div 
                key = {3}
                
                style = {{width:((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.20, border:1, borderColor:'green', borderStyle:'solid',
                            
                            opacity:this.state.SelectedLabels.filter((sl) => sl.Direction == EAST).length ? 
                            0.40
                            :0.15,
                            backgroundColor:'green',
                            cursor:'pointer',
                            position:'absolute',
                            left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*(ClickableParts[0].X + ClickableParts[0].Width - 0.5* ClickableParts[0].Height* 0.20), 
                            top: RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)* (ClickableParts[0].Y +0.2 * ClickableParts[0].Height), 
                            height:0.6 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height
                        }} onClick = {() => {
                            if(!this.state.SelectedLabel.Id){
                                return
                            }
                            
                            let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = ClickableParts[0].Relations.filter((r) => 
                                      r.LabelId == this.state.SelectedLabel.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                  
                    let New = ({
                        Label: this.state.SelectedLabel,
                        Direction: EAST,
                        Questions:Questions,
                        FlowType:  INGOING_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                       SelectedLabel:{}
                    })
                        }}
                        
                        className = {this.state.SelectedLabel.Id ? "border border-warning" : ""}
                        >

                                </div>
            )

            AREAS.push(
                <div 
                
                key = {4}
                style = {{width:0.6 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Width, height:((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.20, border:1, borderColor:'green', borderStyle:'solid',
                            
                            opacity:this.state.SelectedLabels.filter((sl) => sl.Direction == SOUTH).length ? 
                            0.40
                            :0.15,
                            backgroundColor:'green',
                            cursor:'pointer',
                            position:'absolute',
                            left:((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].X + 0.2 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Width, 
                            top:RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Y +((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height - ((RefWidth)/this.props.Question.Base_ImageURL_Width)*ClickableParts[0].Height* 0.10, 
                        }} onClick = {() => {
                            if(!this.state.SelectedLabel.Id){
                                return
                            }
                           
                            let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = ClickableParts[0].Relations.filter((r) => 
                                      r.LabelId == this.state.SelectedLabel.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                        
                

                    let New = ({
                        Label: this.state.SelectedLabel,
                        Direction: SOUTH,
                        Questions:Questions,
                        FlowType:  INGOING_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                       SelectedLabel:{}
                    })
                        }}
                        
                        className = {this.state.SelectedLabel.Id ? "border border-warning" : ""}
                        >

                                </div>
            )

        }

        return(
            <div>
                {this.SetAnswerModal()}
                {this.RelationsModal()}
                {this.AddBoundryConditionModal()}
                {this.EditBoundryConditionModal()}
              {(this.props.IsQuestionSearching  || this.props.IsQuestionSearching == undefined || this.props.GetQuestionError || this.props.GetQuestionError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetQuestionError}/>
                  : <div
                  ref = {'Container_Div'}

                  >
                      
                      <Row

                      >
                        <Col xs = {7} style = {{border:0, borderColor:'green', borderStyle:'solid'}}
                                id = "Container_Col"

                        >
                            <div className = "border border-secondary" ref = {"LABELS_DIV"}>
                                <div style = {{margin:2}}>
                                <Row style={{width:'95%', marginLeft:'2%'}}>
                            
                            <Col xs = {3} style = {{flexDirection:'row', display:'flex'}}>
                            <h6 style = {{color:'#00e600'}}>
                                ♦
                                </h6>
                                <h6 style = {{color:'#cccccc'}}>
                                    Selected to drop
                                </h6>
                                <h6 style = {{color:'#00e600'}}>
                                ♦
                                </h6>
                            </Col>
                            <Col xs = {1}>
                                
                            </Col>
                            <Col xs = {3} style = {{flexDirection:'row', display:'flex'}}>
                            <h6 style = {{color:'#80dfff'}}>
                                ♦
                                </h6>
                                <h6 style = {{color:'#cccccc'}}>
                                    Used in Energy Balance
                                </h6>
                                <h6 style = {{color:'#80dfff'}}>
                                ♦
                                </h6>
                            </Col>
                            <Col xs = {1}>
                              
                            </Col>
                            <Col xs = {4} style = {{flexDirection:'row', display:'flex'}}>
                            <h6 style = {{color:'#cccccc'}}>
                                ♦
                                </h6>
                                <h6 style = {{color:'#cccccc'}}>
                                    Not Used in Energy Balance
                                </h6>
                                <h6 style = {{color:'#cccccc'}}>
                                ♦
                                </h6>
                            </Col>
                            </Row>
                            <Row style={{width:'95%', marginLeft:'2%', 
                            borderTop:1, borderTopColor:'#e6e6e6', borderTopStyle:'solid',
                            borderBottom:1,
                            borderBottomColor:'#e6e6e6',
                            borderBottomStyle:'solid'
                            }}>
                            {this.props.Question.Labels.map((l,i) => 
                            {
                                let color = "#e6e6e6"

                                if(this.state.SelectedLabels.map((sl) => sl.Label.Id).includes(l.Id)){
                                    color = "#ccf2ff"
                                }

                                if(this.state.SelectedLabel.Id == l.Id){
                                    color = "#ccffcc"
                                }

                                return(
                                    <Col 
                                    key = {i}
                                    className = {this.state.HoverLabelId == l.Id ? "border border-primary" : "border border-secondary"}
                            style = {{marginLeft:5, marginBottom:5, marginTop:5,
                                flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                                backgroundColor:color, borderRadius:5
                            }}
                            onClick = {() => {
                            if(this.state.CheckAnswer){
                                return
                            }

                                if (this.state.SelectedLabels.map((sl) => sl.Label.Id).includes(l.Id)){
                                    let SelectedLabels = this.state.SelectedLabels
                                    SelectedLabels = SelectedLabels.filter((sl) => sl.Label.Id != l.Id)

                                    this.setState({
                                        SelectedLabels:SelectedLabels
                                    })

                                    return
                                }
                                
                                if(this.state.SelectedLabel.Id == l.Id){
                                    this.setState({
                                        SelectedLabel: {}
                                    })

                                    return
                                }
                               
                                this.setState({
                                    SelectedLabel: l
                                })
                                

                                
                            }}
                            >   
                                    
                                    <KatexComponent 
                                                height = {50}
                                                text = {'\\Large{'+l.Name.replaceAll('$','')+'}'}
                                                NoBorder = {true}
                                            />
                            </Col>
                                )
                            }
                            )}

                            </Row>
                  
                  <div style = {{
                    width:'95%',
                    marginLeft:'2%',
                    marginTop:5,
                    height: 40
                  }}>
                  <Row style = {{width:'97%', marginLeft:'2%'}}>
                      <div style = {{marginRight: 10}}>
                              <h5 style = {{textDecorationLine: 'underline', color:'#0099cc'}}>
                                  Energy Balance:
                              </h5>
                          </div>
                      {this.state.SelectedLabels.filter((sl) => 
                        [UNSTEADY_FLOW].includes(sl.FlowType)
                      ).length ? 
                     this.state.SelectedLabels.filter((sl) => 
                        [UNSTEADY_FLOW].includes(sl.FlowType)
                      ).map((sl, i) =>(
                          <div key = {i} style = {{marginLeft: 5}}>
                              <SafeLatexViewComponent source = {"$$\\large{"+ sl.Label.Name.replaceAll('$', '')+"}" + "[" + (this.state.SelectedLabels.indexOf(sl)+1) + "]"+ "$$"}/>
                          </div>
                      )):
                        <div style = {{marginLeft: 5}}>
                            <SafeLatexViewComponent source = {"$$\\large{0}$$"}/>
                        </div>}
                      
                      <div style = {{marginLeft: 5}}>
                              <SafeLatexViewComponent source = {"$$\\large{=}$$"}/>
                          </div>
                          {this.state.SelectedLabels.filter((sl) => 
                        [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                      ).length ? 
                      this.state.SelectedLabels.filter((sl) => 
                        [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                      ).map((sl,i) =>(
                          <div key = {i} style = {{flexDirection:'row', display:'flex', marginLeft: 5, borderBottom:0, borderBottomStyle:'solid', borderBottomColor:[INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red"}}>
                              <SafeLatexViewComponent source = {"$$\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\large{"+  ([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "+" : "-")+sl.Label.Name.replaceAll('$', '')+"}}" + "[" + (this.state.SelectedLabels.indexOf(sl)+1) + "]"+ "$$"}/>
                          </div>
                      )) : 
                            <div style = {{marginLeft: 5}}>
                              <SafeLatexViewComponent source = {"$$\\large{0}$$"}/>
                            </div>
                          }
                  </Row>
                  </div>
                  
                                    </div>
                            </div>

                            <div>
                            <img 
                                  style = {{
                                      backgroundPosition:'center',
                                      backgroundRepeat:'no-repeat',
                                      backgroundSize:'contain',
                                      height:(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth,
                                      width:RefWidth,//(this.props.Question.Question.BackgroundImageWidth),
                                      border:0,
                                      borderColor:'#b3b3b3',
                                      borderStyle:'dashed'
                                  }} 
  
                                  src = {this.props.Question.Base_ImageURL}
                                  ref = {'Image_Div'}
                                  onLoad = {(Image) => {
                                      Image.persist()

                                      //var BaseDiv = ReactDOM.findDOMNode(this.props.BaseDiv)
                                      //.getBoundingClientRect()
                                    
                                      var LabelsDiv = ReactDOM.findDOMNode(this.refs['LABELS_DIV'])
                                      .getBoundingClientRect()

                                      var ImageDiv = ReactDOM.findDOMNode(this.refs['Image_Div'])
                                      .getBoundingClientRect()

                                        var Container_Div =  ReactDOM.findDOMNode(this.refs['Container_Div'])

                                      this.setState({
                                          ImageX: ImageDiv.x,
                                          ImageY:  ImageDiv.y,
                                          //BaseY: BaseDiv.y,
                                          RefWidth: Container_Div.children[0].childNodes[0].clientWidth,
                                          RefHeight: LabelsDiv.height,
                                          LinesX:ImageDiv.x,
                                          LinesY:ImageDiv.y,
                                      })
                                  }}

                                  onMouseMove = {(Click) => {
                                    /*if(!this.state.SelectedLabel.Id)
                                    {
                                        return 

                                    }

                                    Click.persist()
            
                                    var ImageDiv = ReactDOM.findDOMNode(this.refs['Image_Div'])
                                    .getBoundingClientRect()
            
                                   
            
                                    let node = ReactDOM.findDOMNode(this.refs['Image_Div']).parentNode 
                                    let nodeStyle = window.getComputedStyle(node)
                                    let padding = nodeStyle.getPropertyValue('padding')
                                    let Offset = parseInt(padding.substring(4,6))
            
                                    /*this.setState({
                                        LinesX: Click.pageX - ImageDiv.x ,
                                        LinesY: Click.pageY - ImageDiv.y + RefHeight
            
                                    })*/
            
                                   
                                    
                               }}
            
                               onMouseEnter = {() => {
                                   
                               }}
            
                               onMouseLeave = {() => {
                                

                            }}

                             />
                             {AREAS}
                             {this.state.SelectedLabels.map((sl, i) => {
                                    let Things = []
                                    let ClickablePart = this.props.Question.ClickableParts[0]
                                    let NX = ClickablePart.NorthX
                                    let NY = ClickablePart.NorthY

                                    let SX = ClickablePart.SouthX
                                    let SY = ClickablePart.SouthY

                                    let EX = ClickablePart.EastX
                                    let EY = ClickablePart.EastY

                                    let WX = ClickablePart.WestX
                                    let WY = ClickablePart.WestY

                                    if(sl.Direction == NORTH){

                                        let NNorth = this.state.SelectedLabels.filter((ssl) => ssl.Direction == NORTH).length
                                        let NIndex = (this.state.SelectedLabels.filter((ssl) => ssl.Direction == NORTH).map((ssl) => ssl.Label.Id).indexOf(sl.Label.Id) +1)
                                        let ShiftNorth = (1/(1+NNorth)) 
    
                                        Things.push(
                                            <div 
                                            id = {"NORTH_2"+NIndex}
                                            key = {4*i + 0}
                                                style = {{
                                                    position:'absolute',
                                                    border:0, borderColor:'red', borderStyle:'solid',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X + ShiftNorth * NIndex * ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top:  RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y,
                                                }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                            id = {"NORTH_1"+NIndex}
                                            key = {4*i + 1}
                                                style = {{
                                                    position:'absolute',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X +  ShiftNorth * NIndex * ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top: RefHeight+ ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y - (this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.15,
                                                }}
                                            />
                                        )
                                        Things.push(
                                            <div 
                                                style = {{
                                                    position:'absolute',
                                                    borderRadius:5,
                                                    cursor:'pointer',

                                                    //backgroundColor:sl.FlowType == INGOING_FLOW ? '#ccffdd' : '#ffe6e6',
                                                    left:NX ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*NX): ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X + 0.55 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top: RefHeight+(NIndex-1)*40 + (NY ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*NY): ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y - (this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.15) ,
                                                }}
                                                key = {4*i + 2}
                                                onClick = {() => {
                                                    
                                                    if(this.state.CheckAnswer){
                                                        return
                                                    }

                                                    let SelectedLabels = this.state.SelectedLabels
                                                    SelectedLabels = SelectedLabels.filter((ssl) => ssl.Label.Id != sl.Label.Id)
        
                                                    this.setState({
                                                        SelectedLabels:SelectedLabels
                                                    })
                                                   }}
                                            >
                                                <div style = {{margin:5}} >
                                                    <h6 style = {{color:'red', marginBottom:0}}>X</h6>
                                                   <div style = {{marginLeft:5}}>
                                                   {/*<LatexViewComponent NoBorder = {true} text =  {"\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\large{"+(i+1)/*sl.Label.Name.replaceAll('$', '')+"}}"}/>*/}
                                                   <h5> {(i+1)}</h5>
                                                   </div>
                                                </div>
                                            </div>
                                        )

                                        Things.push(
                                            <div style ={{cursor:'pointer'}}
                                            key = {4*i + 3}
                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }

                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType =sl.FlowType == INGOING_FLOW ? OUTGOING_FLOW  : INGOING_FLOW
                                                
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            
                                            }}
                                            >
                                                <Xarrow
                                            start={(sl.FlowType == INGOING_FLOW ? "NORTH_1" : "NORTH_2") +NIndex} 
                                            end={(sl.FlowType == INGOING_FLOW ?"NORTH_2" :  "NORTH_1")+NIndex} 
                                            strokeWidth={4}
                                            headSize={5}
                                            startAnchor="auto"
                                            endAnchor="auto"
                                            color={sl.FlowType == INGOING_FLOW ?"green":"red"}
                                            path={"straight"}
                                            />
                                            </div>
                                        )


                                    }

                                    if(sl.Direction == SOUTH){
                                       
                                        let NSouth = this.state.SelectedLabels.filter((ssl) => ssl.Direction == SOUTH).length
                                        let SIndex = (this.state.SelectedLabels.filter((ssl) => ssl.Direction == SOUTH).map((ssl) => ssl.Label.Id).indexOf(sl.Label.Id) +1)
                                        let ShiftSouth = (1/(1+NSouth)) 
    
                                        Things.push(
                                            <div 
                                            id = {"SOUTH_2" + SIndex}
                                            key = {4*i + 0}
                                                style = {{
                                                    position:'absolute',
                                                    border:0, borderColor:'red', borderStyle:'solid',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X + ShiftSouth * SIndex * ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top: RefHeight+ ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height, 
                                                }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                            id = {"SOUTH_1"+ SIndex}
                                            key = {4*i + 1}
                                                style = {{
                                                    position:'absolute',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X + ShiftSouth * SIndex *  ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top:  RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height + (this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.15,
                                               }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                                style = {{
                                                    position:'absolute',
                                                    backgroundColor:'',
                                                    borderRadius:5,
                                                    cursor:'pointer',

                                                    left: SX ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*SX):((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X + 0.5 * ((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top: RefHeight+(SIndex - 1)*40 + (SY ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*SY): ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height + (this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.15),
                                               }}
                                               key = {4*i + 2}
                                               onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels = SelectedLabels.filter((ssl) => ssl.Label.Id != sl.Label.Id)
    
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                               }}
                                            >
                                               <div style = {{margin:5}} >
                                                    <h6 style = {{color:'red', marginBottom:0}}>X</h6>
                                                   <div style = {{marginLeft:5}}  className = "border border-secondary">
{/*<LatexViewComponent NoBorder = {true} text =  {"\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\large{"+(i+1)/*sl.Label.Name.replaceAll('$', '')+"}}"}/>*/}
<h5> {(i+1)}</h5>
                                                   </div>
                                                </div>
                                            </div>
                                        )

                                        Things.push(
                                            <div style ={{cursor:'pointer'}}
                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType =sl.FlowType == INGOING_FLOW ? OUTGOING_FLOW  : INGOING_FLOW
                                                
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            
                                            }}
                                            key = {4*i + 3}
                                            >
                                            <Xarrow
                                            start={(sl.FlowType == INGOING_FLOW ? "SOUTH_1" : "SOUTH_2") + SIndex} 
                                            end={(sl.FlowType == INGOING_FLOW ?"SOUTH_2" :  "SOUTH_1")+ SIndex} 
                                            strokeWidth={4}
                                            headSize={5}
                                            startAnchor="auto"
                                            endAnchor="auto"
                                            color={sl.FlowType == INGOING_FLOW ?"green":"red"}
                                            path={"straight"}
                                            />
                                            </div>
                                        )


                                    }

                                    if(sl.Direction == WEST){
                                        let NWest = this.state.SelectedLabels.filter((ssl) => ssl.Direction == WEST).length
                                        let WIndex = (this.state.SelectedLabels.filter((ssl) => ssl.Direction == WEST).map((ssl) => ssl.Label.Id).indexOf(sl.Label.Id) +1)
                                        let ShiftWest = (1/(1+NWest)) 
    
                                        
                                        Things.push(
                                            <div 
                                            id = {"WEST_2"+WIndex}
                                            key = {4*i + 0}
                                                style = {{
                                                    position:'absolute',
                                                    border:0, borderColor:'red', borderStyle:'solid',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X, 
                                                    top:  RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +WIndex*ShiftWest*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height, 
                                                }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                            id = {"WEST_1"+WIndex}
                                            key = {4*i + 1}
                                                style = {{
                                                    position:'absolute',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X -(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.15,
                                                    top:  RefHeight+((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +WIndex*ShiftWest*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height, 
                                               }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                                style = {{
                                                    position:'absolute',
                                                    borderRadius:5,
                                                    cursor:'pointer',

                                                    left: WX ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*WX):((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X -(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.25,
                                                    top: RefHeight+(WIndex - 1)*40 + (WY ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*WY):((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +0.5*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height), 
                                               }}
                                               key = {4*i + 2}
                                               onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels = SelectedLabels.filter((ssl) => ssl.Label.Id != sl.Label.Id)
    
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                               }}
                                            >
                                                <div style = {{margin:5}} >
                                                    <h6 style = {{color:'red', marginBottom:0}}>X</h6>
                                                   <div style = {{marginLeft:5}}  className = "border border-secondary">
{/*<LatexViewComponent NoBorder = {true} text =  {"\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\large{"+(i+1)/*sl.Label.Name.replaceAll('$', '')+"}}"}/>*/}
<h5> {(i+1)}</h5>
                                                   </div> 
                                                </div>
                                            </div>
                                        )

                                        Things.push(
                                            <div style ={{cursor:'pointer'}}
                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType =sl.FlowType == INGOING_FLOW ? OUTGOING_FLOW  : INGOING_FLOW
                                                
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            
                                            }}
                                            key = {4*i + 3}
                                            >
                                            <Xarrow
                                            start={(sl.FlowType == INGOING_FLOW ? "WEST_1" : "WEST_2")+WIndex} 
                                            end={(sl.FlowType == INGOING_FLOW ?"WEST_2" :  "WEST_1")+WIndex} 
                                            strokeWidth={4}
                                            headSize={5}
                                            startAnchor="auto"
                                            endAnchor="auto"
                                            color={sl.FlowType == INGOING_FLOW ?"green":"red"}
                                            path={"straight"}
                                            />
                                            </div>
                                        )


                                    }

                                    if(sl.Direction == EAST){
                                        let NEast = this.state.SelectedLabels.filter((ssl) => ssl.Direction == EAST).length
                                        let EIndex = (this.state.SelectedLabels.filter((ssl) => ssl.Direction == EAST).map((ssl) => ssl.Label.Id).indexOf(sl.Label.Id) +1)
                                        let ShiftEast = (1/(1+NEast)) 
    
                                      
                                        
                                        Things.push(
                                            <div 
                                            id = {"EAST_2"+EIndex}
                                                style = {{
                                                    position:'absolute',
                                                    border:0, borderColor:'red', borderStyle:'solid',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width, 
                                                    top: RefHeight+ ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +ShiftEast*EIndex*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height, 
                                                }}
                                                key = {4*i + 0}
                                                />
                                        )

                                        Things.push(
                                            <div 
                                            id = {"EAST_1"+EIndex}
                                            key = {4*i + 1}
                                                style = {{
                                                    position:'absolute',
                                                    width:1, height:1,
                                                    left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width +(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.2,
                                                    top: RefHeight+ ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +ShiftEast*EIndex*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height, 
                                               }}
                                            />
                                        )

                                        Things.push(
                                            <div 
                                                style = {{
                                                    position:'absolute',
                                                    cursor:'pointer',
                                                    borderRadius:5,
                                                    left: EX ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*EX):((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].X +((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Width +(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.20,
                                                    top:RefHeight+ (EIndex - 1)*40 +(EY ? (((RefWidth)/this.props.Question.Base_ImageURL_Width)*EY): ((RefWidth)/this.props.Question.Base_ImageURL_Width)*this.props.Question.ClickableParts[0].Y +0.5*((RefWidth)/this.props.Question.Base_ImageURL_Width)* this.props.Question.ClickableParts[0].Height), 
                                               }}
                                               key = {4*i + 2}
                                               onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels = SelectedLabels.filter((ssl) => ssl.Label.Id != sl.Label.Id)
    
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                               }}
                                            >
                                                <div style = {{margin:5}} >
                                                    <h6 style = {{color:'red', marginBottom:0}}>X</h6>
                                                   <div style = {{marginLeft:5}}  className = "border border-secondary">
{/*<LatexViewComponent NoBorder = {true} text =  {"\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\large{"+(i+1)/*sl.Label.Name.replaceAll('$', '')+"}}"}/>*/}
<h5> {(i+1)}</h5>
                                                   </div>
                                                </div>
                                            </div>
                                        )

                                        Things.push(
                                            <div style ={{cursor:'pointer'}}
                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType =sl.FlowType == INGOING_FLOW ? OUTGOING_FLOW  : INGOING_FLOW
                                                
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            
                                            }}
                                            key = {4*i + 3}
                                            >
                                            <Xarrow
                                            start={(sl.FlowType == INGOING_FLOW ? "EAST_1" : "EAST_2")+EIndex} 
                                            end={(sl.FlowType == INGOING_FLOW ?"EAST_2" :  "EAST_1")+EIndex} 
                                            strokeWidth={4}
                                            headSize={5}
                                            startAnchor="auto"
                                            endAnchor="auto"
                                            color={sl.FlowType == INGOING_FLOW ?"green":"red"}
                                            path={"straight"}
                                            />
                                            </div>
                                        )

                                        


                                    }

                                    return Things


                              })}
                             {this.props.Question.ClickableParts.map((p, index) => (
                         
                          <span  key = {index}
                            style = {{
                              position: 'absolute',
                              width: ((RefWidth)/this.props.Question.Base_ImageURL_Width)* p.Width,
                              height: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.Height,
                              left: ((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.X,
                              top:  RefHeight + ((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.Y,
                              backgroundPosition:'center',
                              backgroundRepeat:'no-repeat',
                              backgroundSize:'cover',
                              [p.Background_Image ? "backgroundImage" : ""]:  "url(" + FixURL((p.Background_Image||{URL:''}).URL) + ")",
                              flexDirection:'column',
                              display:'flex',
                              alignItems:'center',
                              alignContent:'center',
                              border:3,
                              borderColor:'#cccccc',
                              borderStyle:'dashed'
                            }}

                            
                          >
                             <Row style = {{width:'100%', height:((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.Height* 0.5
                            , marginTop:((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.Height* 0.25
                            , marginBottom:((RefWidth)/this.props.Question.Base_ImageURL_Width)*p.Height* 0.25}}>
                                
                                <div style = {{width:'60%', border:1, borderColor:'red', borderStyle:'solid',
                            marginLeft:'20%',
                            marginRight:'20%',
                            opacity:this.state.SelectedLabels.filter((sl) => sl.Direction == CENTER).length ? 
                            0.40
                            :0.15,
                            backgroundColor:'red',
                            cursor:'pointer',
                            flexDirection:'column',
                            alignItems:'center',
                            alignContent:'center'
                        }}
                            onClick = {() => {
                                if(!this.state.SelectedLabel.Id){
                                    return
                                }
                                let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = this.props.Question.ClickableParts[0].Relations.filter((r) => 
                                      r.LabelId == this.state.SelectedLabel.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                 

                    let New = ({
                        Label: this.state.SelectedLabel,
                        Direction: CENTER,
                        Questions:Questions,
                        FlowType:  SOURCE_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                       SelectedLabel:{}
                    })
                            }}

                            className = {this.state.SelectedLabel.Id ? "border border-warning" : ""}

                            >
                                <h5 style = {{color:'red', fontWeight:'bold', textAlign:'center'}}></h5>
                                </div>
                                
                            </Row> 
                            
                          
                            
                          </span>
                        ))}

                        {this.state.SelectedLabel.Id && false ?
                        <div style = {{
                            position: 'absolute',
                            top: this.state.LinesY - 50,
                            left: this.state.LinesX - 50
                        }}>
                            <LatexViewComponent
                            NoBorder = {true}
                            text = {'\\large{'+this.state.SelectedLabel.Name.replaceAll('$','')+'}'}
                            />
                        </div>
                        :<div/>}
                       
                        <br/>
                        
                      
                        
                  </div>
                  </Col>
                  <Col xs = {5}>
                      <Row style = {{width:'100%', borderBottom:0, borderBottomColor:'#cccccc', borderBottomStyle:'solid'}}>
                        <Col xs = {9}>
                      <SafeLatexViewComponent source = {this.props.Question.EBLatex}/>
                        
                        </Col>   
                        <Col xs = {1}>
                            {this.state.ShowQuestions ||this.state.ShowRelationModal  && false? 
                            <h5>
                                <Badge style = {{cursor:'pointer'}} color = "danger" onClick = {() => {
                                    this.setState({
                                        ShowRelationModal: false,
                                        ShowQuestions: false,
                                        Questions:[]
                                    })
                                }}>
                                    Back
                                </Badge>
                            </h5> : <div/>}
                        </Col>  
                        {this.state.CheckAnswer ? <div/> : <Col xs = {2}>
                            
                            <h5>
                                <Badge style = {{cursor:'pointer'}} color = "success" onClick = {() => {
                                    if(this.props.Question.BoundryConditions.length && !this.state.BoundryConditions.length){
                                        alert("Please add boundary conditions!")

                                        return 
                                    }

                                    if(!this.state.SelectedLabels.length){
                                        alert("Please add labels!")

                                        return 
                                    }

                                    if(this.state.SelectedLabels.filter((sl) => sl.Answers.filter((a) => !a.List.length).length).length){
                                        alert("Please complete question answers!")

                                        return 
                                    }


                                    let Correct = true;
                                    

                                   let DirectionsCheck = this.state.SelectedLabels.map((sl) => {
                                       let CP = this.props.Question.ClickableParts[0]

                                       let CorrectDirections = CP.Relations.filter((r) => r.LabelId == sl.Label.Id && !r.EB_QuestionId)
                                       .map((r) => r.Direction)

                                       let CurrentDirections = [sl.Direction]

                                       return({
                                        Label:sl,
                                        CorrectDirections:CorrectDirections,
                                        CurrentDirections:CurrentDirections
                                       })
                                   })

                                   let BoundryConditionsCheck = this.state.BoundryConditions.sort((a,b) => a.Index > b.Index ? +1 : -1).map((bc,i) => {
                                    let Correct = false
                                    let Box = ""
                                    let Current_Answer = bc.List.reduce((b,a) => b += a.char, '')
                                    let CAnswer_Equal_Index = Current_Answer.indexOf('=')
                                    let CAnswer_Before = Current_Answer.substring(0, CAnswer_Equal_Index)
                                    let CAnswer_After = Current_Answer.substring(CAnswer_Equal_Index + 1, Current_Answer.length)

                                    console.log(Current_Answer)


                                    for(let B of this.props.Question.BoundryConditions)
                                    {
                                        let Answers = B.Answers

                                        Correct = Answers.filter((a) => {
                                            let Correct_Answer =  a.AnswerElements.reduce((b,a) => b += a.IsInteger ? a.TextPresentation : a.Value, '')
                                            
                                            let KAnswer_Equal_Index = Correct_Answer.indexOf('=')
                                            let KAnswer_Before = Correct_Answer.substring(0, KAnswer_Equal_Index)
                                            let KAnswer_After = Correct_Answer.substring(KAnswer_Equal_Index + 1, Correct_Answer.length)
                                            
                                            let CEquivalent_Answer = CAnswer_Before + "-(" + CAnswer_After + ")"
                                            let KEquivalent_Answer = KAnswer_Before + "-(" + KAnswer_After  + ")"
                                            let FCorrect = (SafeSimplify("(" + KEquivalent_Answer + ")" +  "-" + "(" +CEquivalent_Answer+ ")" )) == '0'
                                            FCorrect = FCorrect || ((SafeSimplify("(" + KEquivalent_Answer + ")" +  "+" + "(" +CEquivalent_Answer+ ")" )) == '0')
                                            console.log("(" + KEquivalent_Answer + ")" +  "-" + "(" +CEquivalent_Answer+ ")")
                                            console.log("(" + KEquivalent_Answer + ")" +  "+" + "(" +CEquivalent_Answer+ ")")
                                            console.log(FCorrect)

                                           return FCorrect
                                        }).length > 0

                                        if(Correct){
                                            Box = B.Code
                                            break
                                        }
                                    }

                                    return({
                                        Correct: Correct,
                                        Box:Box,
                                        simplifiedAnswer: Current_Answer
                                    })

                                   })

                                   let DirectionsCorrect = !DirectionsCheck.filter((dc) =>
                                   !dc.CorrectDirections.includes(dc.Label.Direction)
                                   ).length

                                   let BoundryConditionsCorrect = !BoundryConditionsCheck.filter((bc) => !bc.Correct).length
                                   let ExistingCorrectBCs = GetUniqueValues(BoundryConditionsCheck.filter((bc) => bc.Correct).map((bc) => bc.Box))
                                   BoundryConditionsCorrect &= (ExistingCorrectBCs.length == this.props.Question.BoundryConditions.length)
                                   
                                   let EBLabelsCorrect = false 

                                   /*this.state.PossibleEBs.map((r, ir) => {
                                    let LabelIds = r.map((l) => l.Label.Id)
                                    let Selected = this.state.SelectedLabels.filter((sl) => LabelIds.includes(sl.Label.Id)).length ==  LabelIds.length
                                        */

                                    /*EBLabelsCorrect = !this.state.SelectedLabels.filter((sl) => {
                                        return !this.state.PossibleEBs.filter((r) => {
                                            let LabelIds = r.map((l) => l.Label.Id)

                                            return LabelIds.includes(sl.Label.Id)
                                        }).length
                                    }).length*/

                                    EBLabelsCorrect = this.state.PossibleEBs.filter((r, ir) => {
                                        let LabelIds = r.map((l) => l.Label.Id)
                                        let Selected = (this.state.SelectedLabels.filter((sl) => LabelIds.includes(sl.Label.Id)).length ==  LabelIds.length) && (this.state.SelectedLabels.length == LabelIds.length)
                                        return Selected
                                    }).length

                                    let SelectedLabels = this.state.SelectedLabels
                                    
                                    for(let SL of SelectedLabels){
                                        SL.AnswersStatus = [...SL.Answers.map((a) => false)]
                                        SL.AnswersIndex = [...SL.Answers.map((a) => -1)]
                                        
                                        for(let i=0;i<SL.Answers.length;i++){
                                            let Chars = GetAnswerCharArray()

                                            var Numeric = Chars["Numeric"].reduce((a,x) => ({...a, [x]: []}), {})
                                            var Variable = Chars["Variable"].reduce((a,x) => ({...a, [x]: []}), {})

                                            console.log(Numeric)
                                            console.log(Variable)


                                            let a = SL.Answers[i]

                                            let Current_Answer = a.List.reduce((b,a) => {
                                                if(!a.IsInteger && !a.NumericKeyId && !a.ImageId){
                                                    b += a.char

                                                    return b 
                                                }

                                                if(a.IsInteger){
                                                    b += a.char

                                                    return b
                                                }
                                                
                                                if(a.NumericKeyId){
                                                    
                                                    for(let n in Numeric){
                                                        if(!Numeric[n].length){
                                                            Numeric[n].push(a.NumericKeyId)
                                                            
                                                            console.log(n)
                                                            
                                                            b += n
                                                            break
                                                        }

                                                        if(Numeric[n].length && Numeric[n][0] == a.NumericKeyId){
                                                            Numeric[n].push(a.NumericKeyId)
                                                            console.log(n)

                                                            b += n
                                                            break
                                                        }
                                                        else{
                                                        }
                                                    }

                                                    return b
                                                }

                                                if(a.VariableImageId){
                                                    for(let v in Variable){
                                                        if(!Variable[v].length){
                                                            Variable[v].push(a.VariableImageId)

                                                            b += v
                                                            break
                                                        }

                                                        if(Variable[v].length && Variable[v][0] == a.VariableImageId){
                                                            Variable[v].push(a.VariableImageId)

                                                            b += v
                                                            break
                                                        }
                                                        else{
                                                        }
                                                    }

                                                    return b
                                                }

                                            }, '')

                                            console.log(Numeric)
                                            console.log(Variable)

                                            let q = SL.Questions[i]

                                            let Answers = q.Answers
                                            .sort((a,b) => a.Id > b.Id ? 1 : -1)
                                            .map((a, i) => {
    
                                                let Correct = false
                                                let FlipCorrectAnswer = ((!q.Ingoing) && (SL.FlowType == INGOING_FLOW)) ||((q.Ingoing) && (SL.FlowType == OUTGOING_FLOW))
                                                let primilinary_correct_answer = a.AnswerElements.sort((a,b) => a.Id > b.Id ? +1 : -1 ).reduce((c,a) => {
                                                    if(!a.IsInteger && !a.NumericKeyId && !a.ImageId){
                                                        c += a.Value
    
                                                        return c
                                                    }
    
                                                    if(a.IsInteger){
                                                        c += a.TextPresentation
    
                                                        return c
                                                    }
                                                    
                                                    if(a.NumericKeyId){
                                                        
                                                        for(let n in Numeric){
                                                            if(!Numeric[n].length){
                                                                Numeric[n].push(a.NumericKeyId)
    
                                                                c += n
                                                                break
                                                            }
    
                                                            if(Numeric[n].length && Numeric[n][0] == a.NumericKeyId){
                                                                Numeric[n].push(a.NumericKeyId)
    
                                                                c += n
                                                                break
                                                            }
                                                            else{
                                                            }
                                                        }
    
                                                        return c
                                                    }
    
                                                    if(a.ImageId){
                                                        for(let v in Variable){
                                                            if(!Variable[v].length){
                                                                Variable[v].push(a.ImageId)
    
                                                                c += v
                                                                break
                                                            }
    
                                                            if(Variable[v].length && Variable[v][0] == a.ImageId){
                                                                Variable[v].push(a.ImageId)
    
                                                                c += v
                                                                break
                                                            }
                                                            else{
                                                            }
                                                        }

                                                        return c
                                                    }
                                                }, '') 

                                                console.log(Current_Answer)
                                                console.log(primilinary_correct_answer)

                                                let correct_answer = (FlipCorrectAnswer ?"-(" : "(") + primilinary_correct_answer + ")" +  "-" + "(" +Current_Answer+ ")" 
                                                Correct = (SafeSimplify(correct_answer) == '0')

    
                                                return({
                                                    Correct: Correct, 
                                                    Index: i
                                                })
                                            })

                                            SL.AnswersStatus[i] = Answers.filter((a) => a.Correct).length
                                            SL.AnswersIndex[i] = Answers.filter((a) => a.Correct).length ? Answers.filter((a) => a.Correct)[0].Index : -1 



                                        }
                                    }

                                    let QuestionsCorrect = !SelectedLabels
                                    .filter((sl) => sl.AnswersStatus.filter((a) => !a).length).length

                                   this.setState({
                                       DirectionsCheck: DirectionsCheck,
                                       DirectionsCorrect:DirectionsCorrect ,
                                       BoundryConditionsCheck:BoundryConditionsCheck,
                                       BoundryConditionsCorrect:BoundryConditionsCorrect,
                                       ExistingCorrectBCs:ExistingCorrectBCs,
                                       EBLabelsCorrect:EBLabelsCorrect,
                                       QuestionsCorrect:QuestionsCorrect,
                                       SelectedLabels:SelectedLabels,
                                       CheckAnswer: true
                                   })

                                   Correct = QuestionsCorrect && BoundryConditionsCorrect && DirectionsCorrect && EBLabelsCorrect

                                   if(this.props.Object) {
                                    let QuestionsAnswers = this.props.Object.state.QuestionsAnswers
                                    let QuestionsAnswersFull = this.props.Object.state.QuestionsAnswersFull

                                    QuestionsAnswers[this.props.Object.state.CurrentIndex] = {
                                        Id: this.props.Question.Id,
                                        Answered: true,
                                        Score: Correct ? '1/1' : '0/1',
                                        Correct: Correct
                                    }


                                    QuestionsAnswersFull[this.props.Object.state.CurrentIndex] = []

                                    this.props.Object.setState({
                                        QuestionsAnswers:QuestionsAnswers,
                                        QuestionsAnswersFull: QuestionsAnswersFull
                                    })

                                    
                                    
                                }
                                }}>
                                    Check answer
                                </Badge>
                            </h5>
                        </Col>      }                 
                      </Row>
                      {this.state.SelectedLabels.length ? 
                    <div  className = "border border-secondary" style = {{width:'95%', marginLeft:'2%', marginBottom:'2%'}}>
                        <div style = {{margin:5}}>
                        <Row style = {{width:'100%'}}>
                            <Col xs = {12}>
                            <SafeLatexViewComponent source = {this.props.Question.EBFLatex}/>

                            </Col>
                        </Row>
                        </div>
                    </div>  
                    : <div/>}
                      <div style = {{height:(this.props.Question.Base_ImageURL_Height/this.props.Question.Base_ImageURL_Width)*RefWidth * 0.9 + RefHeight, overflowY:'scroll', width:'100%'}}>
                      
                      
                      {(this.state.SelectedLabels).map((l,i) => (
                          <div  
                          className = "border border-secondary" 
                          style = {{width:'95%', marginLeft:'2%', marginBottom:'2%', border:0,
                          backgroundColor:'#f2f2f2'}}
                          key = {i}
                          >
                          <div style = {{margin:5}}>
                          <Row style = {{width:'100%'}}>
                          <Col xs = {2}>
                                  {[NORTH, SOUTH, EAST, WEST].includes(l.Direction) ? 
                                  <div>
                                      <p style = {{marginBottom:5}}>
                                        <Badge color = {l.FlowType == INGOING_FLOW ? "primary" : "secondary"}
                                            style = {{cursor:'pointer'}}

                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return 
                                                }

                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType = INGOING_FLOW
    
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            }}
                                        
                                        >
                                            Ingoing 
                                        </Badge>
                                      </p>
                                      <p>
                                      <Badge color = {l.FlowType == OUTGOING_FLOW ? "primary" : "secondary"}
                                      style = {{cursor:'pointer'}}

                                      onClick = {() => {
                                        if(this.state.CheckAnswer){
                                            return 
                                        }
                                          let SelectedLabels = this.state.SelectedLabels
                                          SelectedLabels[i].FlowType = OUTGOING_FLOW

                                          this.setState({
                                              SelectedLabels:SelectedLabels
                                          })
                                      }}
                                      >
                                            Outgoing 
                                        </Badge>
                                      </p>
                                  </div> : <div/>}

                                  {[CENTER].includes(l.Direction) ? 
                                  <div>
                                      <p style = {{marginBottom:5}}>
                                        <Badge color = {l.FlowType == SOURCE_FLOW ? "primary" : "secondary"}
                                            style = {{cursor:'pointer'}}

                                            onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return 
                                                }
                                                let SelectedLabels = this.state.SelectedLabels
                                                SelectedLabels[i].FlowType = SOURCE_FLOW
    
                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                                            }}
                                        
                                        >
                                            Source 
                                        </Badge>
                                      </p>
                                      <p>
                                      <Badge color = {l.FlowType == UNSTEADY_FLOW ? "primary" : "secondary"}
                                      style = {{cursor:'pointer'}}

                                      onClick = {() => {
                                        if(this.state.CheckAnswer){
                                            return 
                                        }
                                          let SelectedLabels = this.state.SelectedLabels
                                          SelectedLabels[i].FlowType = UNSTEADY_FLOW

                                          this.setState({
                                              SelectedLabels:SelectedLabels
                                          })
                                      }}
                                      >
                                            Unsteady 
                                        </Badge>
                                      </p>
                                  </div> : <div/>}
                              </Col>
                              <Col xs = {9} style = {{marginLeft:0}}
                              
                              onClick = {() => {
                                  /*let CV = this.state.SelectedCV

                                  let Relations = CV.Relations.filter((r) => 
                                      r.LabelId == l.Id && r.Direction == this.state.SelectedDirection
                                  ).map((r) => r.EB_QuestionId)

                                  console.log(Relations)

                                  let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
                                  console.log(Questions)
                                  console.log(this.props.Question.Questions)

                                  this.setState({
                                    Questions:Questions,
                                    ShowQuestions: true,
                                    ShowRelationModal: false
                                  })*/
                              }}
                              >
                                                <SafeLatexViewComponent source = {"$$\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(l.FlowType) ? "green" : "red")+"}{\\LARGE{"+ l.Label.Name.replaceAll('$', '')+"}}$$"}/>
                              </Col>
                              
                              {this.state.CheckAnswer ? <div/> : <Col xs = {1}>
                                <h5>
                                        <Badge color = "danger" style = {{cursor:'pointer'}} onClick = {() => {
                                            if(this.state.CheckAnswer){
                                                return 
                                            }
                                            let SelectedLabels = this.state.SelectedLabels
                                            SelectedLabels = SelectedLabels.filter((sl) => sl.Label.Id != l.Label.Id)

                                            this.setState({
                                                SelectedLabels:SelectedLabels
                                            })
                                        }}>
                                        X
                                        </Badge>
                                </h5>
                            </Col>}
                          </Row>
                          <LineComponent Color = "#99e7ff"/>
                          {l.Questions.map((q, ii) => {
                        let OtherLabels = this.state.SelectedLabels
                        .filter((sl) => sl.Label.Id != l.Label.Id &&  sl.Questions.map((qq) => qq.Id).includes(q.Id))

                              return(
                                <div style = {{margin:0, width:'100%', marginBottom:10,
                                border:0, borderColor:'#cccccc', borderStyle:'solid'}} key = {ii}>
                                      <Row  style = {{width:'100%'}}>
                                          <Col xs = {1}> 
                                              <h5 style = {{color:'#0099cc', textAlign:'center', fontWeight:'bold'}}>{ii+1}</h5>
                                          </Col>
                                          {this.state.CheckAnswer ? <div/> : <Col xs = {1}>
                                      {!l.Answers[ii].List.length? '❌' : '✔️'}
                                      </Col>}
                                      <Col xs = {8}>
                                      <SafeLatexViewComponent source = {"$$\\large{"+q.Latex.replaceAll('$', '')+"}$$"}/>
                                      
                                      </Col>
                                      {this.state.CheckAnswer ? <div/> : <Col xs = {2} >
                                      <h5 style = {{textAlign:'right', width:'100%'}}>
                                              <Badge 
                                              color = "primary" 
                                              style = {{cursor:'pointer', textAlign:'right'}}
                                              onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return 
                                                }
                                                  this.setState({
                                                      ShowAnswerModal: true,
                                                      SelectedAnswer: q,
                                                      SelectedLabelIndex: i,
                                                      SelectedAnswerIndex:ii
                                                  })
                                              }}
                                              >
                                                  Answer
                                              </Badge>
                                          </h5>
                                      </Col>}
                                      
                                      </Row>
                             
                              <Row style = {{width:'100%'}}>
                              <Col xs = {10} 
                              style = {{marginLeft:'3%', marginRight:'5%',
                                  flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center',
                                  overflowX: 'scroll',
                                  height:80,
                                  borderBottom:1, borderBottomColor:'#e6e6e6', borderBottomStyle:'solid'
                              }}
                              >
                                      <SafeLatexViewComponent 
                                          source = {"$\\large{"+ l.Answers[ii].List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                      />
                                  </Col>
                                  {this.state.CheckAnswer ? <div/> : <Col
                           style = {{marginLeft:0, marginBottom:0,
                              flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                              //backgroundColor:'#ffe6e6'
                          }}                        
                          xs = {1}>
                              <h5>
                                      <Badge 
                                      color = "danger" 
                                      style = {{cursor:'pointer'}}
                                      onClick = {() =>{
                                        if(this.state.CheckAnswer){
                                            return 
                                        }
                                        let SelectedLabels = this.state.SelectedLabels
                                        SelectedLabels[i].Answers[ii].List = []
                                        this.setState({
                                          SelectedLabels:SelectedLabels
                                          })
                                      }}
                                      >
                                          Clear
                                      </Badge>
                                  </h5>
                          </Col>}
                              </Row>
                               <br/>

                              {false &&OtherLabels.length ? 
                              <Row style = {{width:'100%'}}>
                                  <Col xs = {4}>
                                      <p style = {{color:'#0099cc'}}>Copy answer from label</p>
                                  </Col>
                                  <Col xs = {8}>
                                      {OtherLabels.map((ol) => (
                                          <div>
                                          <div style = {{margin:5, cursor:'pointer'}} 
                                          onMouseEnter = {() =>  {
                                              this.setState({
                                                  HoverLabelId: ol.Label.Id
                                              })
                                          }}

                                          onMouseLeave = {() => {
                                            this.setState({
                                                HoverLabelId: undefined
                                            })
                                          }}

                                          onClick = {() => {
                                              let SelectedLabels = this.state.SelectedLabels
                                              let Answer = ol.Answers.filter((a,i) => {
                                                 return(ol.Questions[i].Id == q.Id)
                                              })[0]

                                              SelectedLabels[i].Answers[ii].List = [...Answer.List]

                                              this.setState({
                                                SelectedLabels:SelectedLabels
                                              })
                                          }}>
                                                <SafeLatexViewComponent source = {"$$\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(ol.FlowType) ? "green" : "red")+"}{\\large{"+ ol.Label.Name.replaceAll('$', '')+"}}$$"}/>

                                          </div>
                                          </div>
                                        ))}
                                  </Col>
                              </Row>
                                :<div/>}
                              {ii != (l.Questions.length - 1) ? 
                              <LineComponent Color = "#99e7ff"/> : <div/>}

                          </div>
                            )
                          })}
                          </div>
                          </div>

                      ))}

{this.props.Question.BoundryConditions && this.props.Question.BoundryConditions.length ?
                       <div  className = "border border-secondary" 
                       style = {{width:'95%', marginLeft:'2%', marginBottom:'2%', border:0,
                          backgroundColor:'#ccf2ff'}}
                       >
                        <div style = {{margin:5}}>
                            <Row style = {{width:'100%'}}>
                            {this.state.CheckAnswer ? 
                            <Col xs = {4}>
                                    <h5>
                                        <Badge color = "primary" onClick = {() => {
                                           
                                        }}>
                                            Boundary conditions
                                        </Badge>
                                    </h5>
                                </Col> : <Col xs = {4}>
                                    <h5>
                                        <Badge color = "success" style = {{cursor:'pointer'}} onClick = {() => {
                                            if(this.state.CheckAnswer){
                                                return 
                                            }
                                            this.setState({
                                                ShowAddBoundryCondition: true,
                                                NewBoundryCondition:{
                                                    List:[],
                                                    Index: this.state.BoundryConditions.length + 1
                                                }
                                            })
                                        }}>
                                            Add boundary condition
                                        </Badge>
                                    </h5>
                                </Col>}
                                <Col xs = {7}>
                                </Col>
                                {this.state.CheckAnswer ? <div/> : <Col xs = {1}>
                             {!this.state.BoundryConditions.length? '❌' : '✔️'}
                             </Col>}
                            </Row>
                            <hr/>
                            {this.state.BoundryConditions.map((bc,ib)=>(
                                <Row key = {ib} style = {{width:'95%', marginLeft:'2%'}}> 
                                    <Col xs = {1}>
                                        <h5 style = {{color:'#0099cc', textAlign:'center', fontWeight:'bold'}}>
                                            {ib+1}
                                        </h5>
                                    </Col>
                                    <Col xs = {9}>
                                    <SafeLatexViewComponent 
                                     source = {"$\\large{"+ bc.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                 />
                                    </Col>
                                    {this.state.CheckAnswer ? <div/> : <Col xs = {1}>
                                       <h5>
                                           <Badge color = "primary" style = {{cursor:'pointer'}} onClick = {() => {
                                               if(this.state.CheckAnswer){
                                                return 
                                            }

                                                this.setState({
                                                    ShowEditBoundryCondition:true,
                                                    SelectedAnswerIndex: ib
                                                })
                                           }}>
                                               Edit
                                           </Badge>
                                       </h5>
                                    </Col>}
                                    {this.state.CheckAnswer ? <div/> : <Col xs = {1}>
                                       <h5>
                                           <Badge color = "danger" style = {{cursor:'pointer'}} onClick = {() => {
                                                if(this.state.CheckAnswer){
                                                    return 
                                                }

                                               let BoundryConditions = this.state.BoundryConditions
                                               BoundryConditions = BoundryConditions.filter((b,ri) => ri != ib)

                                               this.setState({
                                                BoundryConditions:BoundryConditions
                                               })
                                           }}>
                                               X
                                           </Badge>
                                       </h5>
                                    </Col>}
                                </Row>
                            ))}
                        </div>
                        </div>
                        
                        : <div/>}
                      
                      {(this.state.ShowQuestions && false ? this.state.Questions : []).map((q,i) =>{


                          return (
                            <div style = {{margin:5, width:'95%', marginTop:20,
                                          border:1, borderColor:'#cccccc', borderStyle:'solid'}} key = {i}>
                              <Row  style = {{width:'100%'}}>
                              <Col xs = {10} style = {{marginLeft:'2%', marginRight:'5%'}}>
                              <SafeLatexViewComponent source = {q.Latex}/>
                              
                              </Col>
                              <Col xs = {1}>
                              <h5>
                                      <Badge 
                                      color = "primary" 
                                      style = {{cursor:'pointer'}}
                                      onClick = {() => {
                                          this.setState({
                                              ShowAnswerModal: true,
                                              SelectedAnswer: q,
                                              SelectedAnswerIndex:this.state.QuestionAnswers.map((a) => a.Id).findIndex((b) => b == q.Id)
                                          })
                                      }}
                                      >
                                          Answer
                                      </Badge>
                                  </h5>
                              </Col>
                              </Row>
                              <hr/>
                              {this.state.QuestionAnswers[this.state.QuestionAnswers.map((a) => a.Id).findIndex((b) => b == q.Id)] ? 
                              <Row style = {{width:'100%'}}>
                              <Col xs = {10} 
                              style = {{marginLeft:'3%', marginRight:'5%',
                                  flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center',
                                  overflowX: 'scroll',
                                  height:70,
                                  borderBottom:2, borderBottomColor:'green', borderBottomStyle:'solid'
                              }}
                              >
                                                                     </Col>
                                  <Col
                           style = {{marginLeft:0, marginBottom:0,
                              flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                              //backgroundColor:'#ffe6e6'
                          }}                        
                          xs = {1}>
                              <h5>
                                      <Badge 
                                      color = "danger" 
                                      style = {{cursor:'pointer'}}
                                      onClick = {() =>{
                                          let QuestionAnswers = this.state.QuestionAnswers
                                          let Index = QuestionAnswers.map((a) => a.Id).findIndex((b) => b == q.Id)
                                          let Answer = this.state.QuestionAnswers[Index]
                                          let Last = this.state.QuestionAnswers[Index].List.slice(-1)[0]
                                                             if(!Answer.List.length)
                                                              {
                                                                  return
                                                              }
              
                                                              Answer.echoNumber = 0
              
                                                              Answer.List = []
              
                                                              this.setState({
                                                                  QuestionAnswers:QuestionAnswers
                                                              })
                                      }}
                                      >
                                          Clear
                                      </Badge>
                                  </h5>
                          </Col>
                              </Row> : <div/>}
                              
                            </div>
                        )
                      })}
                      </div>
                  </Col>
                  </Row>
                  
                {this.state.CheckAnswer ? <LineComponent Color = "#99e7ff"/> : <div/>}
                {/*this.state.CheckAnswer ? 
                <Row  style = {{width:'95%', marginLeft:'2%'}}>
                        <Col xs = {4}>
                            <h4 style = {{color:'#0099cc'}}>
                                Answer evaluation 
                            </h4>
                        </Col>
                    </Row>: <div/>}
                {this.state.CheckAnswer ?                           <LineComponent Color = "#99e7ff"/>
 : <div/>*/}

                {this.state.CheckAnswer ? 
                <div style = {{margin:5}}>
                    <Row style = {{width:'95%', marginLeft:'2%',}}>
                    <Col xs = {4}>
                                    { this.props.Question.PDFURL ?<h4>
                                            <Badge color = {'danger'}
                                            style = {{cursor:'pointer'}}
                                            onClick = {() => {
                                                window.open(this.props.Question.PDFURL)  
                                            }}
                                            >
                                                PDF Solution
                                            </Badge>
                                        </h4>: <div/>}
                                            {this.props.Question.VIDEOURL ?
                                            <h4>
                                                <Badge color = {'primary'}
                                                style = {{cursor:'pointer'}}
                                                onClick = {() => {
                                                    window.open(this.props.Question.VIDEOURL)  
                                                }}
                                                >
                                                    Video Solution
                                                </Badge>
                                            </h4> : <div/>}
                                        </Col> 
                    </Row>
                    {(this.props.Question.VIDEOURL ||this.props.Question.PDFURL ) ? <hr/> : <div/>}
                    {this.props.Question.BoundryConditions.length ? 
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {3}
                        className = "border border-primary"
                        style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center', borderRadius:20,backgroundColor:'#e6faff'}}>
                           <div style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center',}}>
                           <h5 style = {{color:'#0099cc'}} >
                                Boundary Conditions {this.state.ExistingCorrectBCs.length}/{this.props.Question.BoundryConditions.length} - {!this.state.BoundryConditionsCorrect ? '❌' : '✔️'}
                            </h5>
                           </div>
                        </Col>
                        
                    </Row>
                        : <div/>}
                    {this.props.Question.BoundryConditions.length ? 
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {4}>
                            <h5 style = {{color:'#0099cc'}}>
                                Correct boundary conditions boxes
                            </h5>
                        </Col>
                    </Row>
                    : <div/>}

                    {this.props.Question.BoundryConditions.length ? 
                    (this.props.Question.BoundryConditions.map((bc,i) => (
                        <Row key = {i} style = {{width:'95%', marginLeft:'2%'}} >
                            <Col xs = {1}>
                               
                            </Col>
                            {/*<Col xs = {3}>
                                
                                <SafeLatexViewComponent 
                                    source = {"$$\\large{"+(bc.Code).replaceAll('$', '')+"}$$"}
                                />
                            </Col>*/}
                            <Col xs = {8}>
                                {bc.Answers.map((a,ii) => (
                                    <Row key = {ii}>
                                        <Col xs = {12}>
                                        <SafeLatexViewComponent 
                                    source = {'$$\\large{'  + a.AnswerElements.sort((c,d) => c.Id > d.Id ? 1 : -1).reduce((a,b) => a += ' ' + (b.TextPresentation || (b.Value == '*' ? '\\cdot': b.Value)), '') + '}$$'} 
                                   />
                                        </Col>
                                    </Row>
                                ))}
                            </Col>
                        </Row>
                    )))
                    : <div/>}
                    <br/>
                    {this.props.Question.BoundryConditions.length ? 
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {4}>
                            <h5 style = {{color:'#0099cc'}}>
                                Added boundary conditions 
                            </h5>
                        </Col>
                    </Row>
                    : <div/>}
                    {this.props.Question.BoundryConditions.length ? 
                    (this.state.BoundryConditions.sort((a,b) => a.Index > b.Index ? +1 : -1).map((bc,i) => (
                        <Row key = {i} style = {{width:'95%', marginLeft:'2%'}}>
                            <Col xs = {1}>
                                {/*!this.state.BoundryConditionsCheck[i].Correct? '❌' : '✔️'*/}
                            </Col>
                            {/*<Col xs = {3}>
                            
                                <SafeLatexViewComponent 
                                    source = {"$$\\color{green}{\\large{"+(!this.state.BoundryConditionsCheck[i].Correct? "" : this.state.BoundryConditionsCheck[i].Box).replaceAll('$', '')+"}}$$"}
                                />
                            </Col>*/}
                            <Col xs = {8} >
                                <SafeLatexViewComponent 
                                    source = {"$$\\color{"+(this.state.BoundryConditionsCheck[i].Correct?"green" : "red") +"}{\\large{"+ bc.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}}$$"}
                                />
                            </Col>
                        </Row>
                    ))) : <div/>}
                    {false && this.props.Question.BoundryConditions.length ? <div style = {{width:'40%', marginLeft:'2%', borderBottom:2, borderBottomColor:'#bfbfbf', borderBottomStyle:'solid', marginBottom:10}}/> : <div/>}
                    {false && this.props.Question.BoundryConditions.length ?
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {1}>
                            <h5 style = {{color:'#bfbfbf'}}>
                               Included
                            </h5>
                        </Col>
                        {this.props.Question.BoundryConditions.filter((qbc) => {
                            return this.state.BoundryConditionsCheck.filter((bcc) => bcc.Box == qbc.Code).length 
                        }).map((bc,i) => 
                        <Col style = {{margin:2}} key = {i}>
                            <SafeLatexViewComponent 
                                    source = {"$$\\color{green}{\\large{"+bc.Code.replaceAll('$', '')+"}}$$"}
                                />
                        </Col>)}
                        
                    </Row>
                    
                    : <div/>}
                    { false && this.props.Question.BoundryConditions.length ?
                    <Row  style = {{width:'95%', marginLeft:'2%'}}>
                        <Col xs = {1}>
                            <h5 style = {{color:'#bfbfbf'}}>
                               Missing
                            </h5>
                        </Col>
                        
                        <Col xs = {10}>
                        {this.props.Question.BoundryConditions.filter((qbc) => {
                            return !this.state.BoundryConditionsCheck.filter((bcc) => bcc.Box == qbc.Code).length 
                        }).map((bc,i) => 
                        <Row style = {{margin:2}} key = {i}>
                            <SafeLatexViewComponent 
                                    source = {"$$\\color{red}{\\large{"+bc.Code.replaceAll('$', '')+"}}$$"}
                                />
                        </Row>)}
                        </Col>
                    </Row>
                    
                    : <div/>}

                    {this.props.Question.BoundryConditions.length ?                           <LineComponent Color = "#99e7ff"/>
 : <div/>}
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {2}
                        className = "border border-primary"
                        style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center', borderRadius:20,backgroundColor:'#e6faff'}}>
                           <div style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center',}}>
                           <h5 style = {{color:'#0099cc'}} >
                                Label Positions {!this.state.DirectionsCorrect ? '❌' : '✔️'}
                            </h5>
                           </div>
                        </Col>
                       
                    </Row>
                    <br/>
                        <Row>
                            <Col xs = {4}>
                            <Row style = {{width:'95%', marginLeft:'2%'}}>
                            <div style = {{
                            width:100, height:0,
                            border:0,
                            borderColor:'#cccccc',
                            borderStyle:'dashed'
                            }}/>
                        <div style = {{width:200, flexDirection:'column', alignContent:'center', alignItems:'center', display:'flex'}} >
                        <LatexViewComponent NoBorder = {true} text = {"NORTH"}/>

                        </div>
                        
                       
                    </Row>
                    
                    <Row style = {{width:'95%', marginLeft:'2%'}}>
                    <div style = {{
                            width:100, height:200,
                            border:0,
                            borderColor:'#cccccc',
                            borderStyle:'dashed'
                            }}>
                                <LatexViewComponent NoBorder = {true} text = {"WEST"}/>

                        </div>
                        
                        <div style = {{
                            width:200, height:200,
                            border:3,
                            borderColor:'#cccccc',
                            borderStyle:'dashed'
                            }}>
                                <LatexViewComponent NoBorder = {true} text = {"CENTER"}/>
                        </div>
                        
                        <div style = {{
                            width:100, height:200,
                            border:0,
                            borderColor:'#cccccc',
                            borderStyle:'dashed'
                            }}>
                                <LatexViewComponent NoBorder = {true} text = {"EAST"}/>

                        </div>
                        
                    </Row>
                    <Row style = {{width:'95%', marginLeft:'2%'}}>
                        <div style = {{
                            width:100, height:0,
                            border:0,
                            borderColor:'#cccccc',
                            borderStyle:'dashed'
                            }}/>
                        <div style = {{width:200, flexDirection:'column', alignContent:'center', alignItems:'center', display:'flex'}}>
                        <LatexViewComponent NoBorder = {true} text = {"SOUTH"}/>

                        </div>
                        
                    </Row>
                            </Col>
                            <Col xs = {8}>
                                <Row>
                                    <Col xs = {2}></Col>
                                    <Col xs = {5}>
                                    <h5 style = {{color:'#0099cc'}}>
                                        Selected labels 
                                    </h5>
                                    
                                    </Col>
                                    <Col xs = {5}>
                                    <h5 style = {{color:'#0099cc'}}>
                                        Correct labels 
                                    </h5>
                                    </Col>
                                </Row>
                                <br/>
                                {this.state.SelectedLabels.filter((r) => r.Direction == NORTH).length ? 
                                <Row>
                                    <Col xs = {2}>
                                    <LatexViewComponent NoBorder = {true} text = {"NORTH"}/>
                                    </Col>
                                    <Col xs = {5}>
                                    {this.state.SelectedLabels.filter((r) => r.Direction == NORTH)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == NORTH && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div
                                                id = {"LABEL_S_N"+r.Label.Id}
                                                key = {i}
                                                >
                                                <div style={{margin:3}}

                                                >
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                    {/*<Xarrow
                                                    start={"LABEL_C_N"+r.Label.Id} 
                                                    end={"LABEL_S_N"+r.Label.Id} 
                                                    strokeWidth={1}
                                                    headSize={2}
                                                    startAnchor="auto"
                                                    endAnchor="auto"
                                                    color={"green"}
                                                    path={"straight"}
                                                    />*/}
                                                </div>
                                    ))}


                    {this.state.SelectedLabels.filter((r) => r.Direction == NORTH)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return !this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == NORTH && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div key = {i}>
                                                <div style={{margin:3}}>
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{red}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                </div>
                                    ))}
                                    </Col>
                                    <Col xs = {5}>
                                    {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == NORTH && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return this.state.SelectedLabels.filter((r) => r.Direction == NORTH)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div
                                            key = {i}
                                            style = {{flexDirection:'row', display:'flex'}}
                                            >
                                            <div style={{margin:3}}
                                            
                                            >   
                                                <SafeLatexViewComponent 
                                            source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />
                                                
                                                </div>
                                                
                                            </div>
                                        )
                                        
                                       
                                    })}
                                     {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == NORTH && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return !this.state.SelectedLabels.filter((r) => r.Direction == NORTH)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div key = {i}>
                                            <div style={{margin:3}}
                                        >
                                                <SafeLatexViewComponent 
                                            source = {"$$\\large{"+ r.Label.Name.replaceAll('$','')+ "}$$"} />

                                                </div>
                                            </div>
                                        )
                                       
                                    })}
                                    </Col>
                                   
                                </Row> : <div/>}
                                {this.state.SelectedLabels.filter((r) => r.Direction == EAST).length ? 
                                <hr/> : <div/>}


                                {this.state.SelectedLabels.filter((r) => r.Direction == EAST).length ? 
                                <Row>
                                    <Col xs = {2}>
                                    <LatexViewComponent NoBorder = {true} text = {"EAST"}/>
                                    </Col>
                                    
                                    <Col xs = {5}>
                                    {this.state.SelectedLabels.filter((r) => r.Direction == EAST)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == EAST && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div
                                                key = {i}
                                                id = {"LABEL_S_N"+r.Label.Id}
                                                
                                                >
                                                <div style={{margin:3}}

                                                >
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                    {/*<Xarrow
                                                    start={"LABEL_C_N"+r.Label.Id} 
                                                    end={"LABEL_S_N"+r.Label.Id} 
                                                    strokeWidth={1}
                                                    headSize={2}
                                                    startAnchor="auto"
                                                    endAnchor="auto"
                                                    color={"green"}
                                                    path={"straight"}
                                                    />*/}
                                                </div>
                                    ))}


                    {this.state.SelectedLabels.filter((r) => r.Direction == EAST)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return !this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == EAST && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div key = {i}>
                                                <div style={{margin:3}}>
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{red}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                </div>
                                    ))}
                                    </Col>
                                    <Col xs = {5}>
                                    {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == EAST && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return this.state.SelectedLabels.filter((r) => r.Direction == EAST)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div
                                            key = {i}
                                            style = {{flexDirection:'row', display:'flex'}}
                                            >
                                            <div style={{margin:3}}
                                            
                                            >   
                                                <SafeLatexViewComponent 
                                            source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />
                                                
                                                </div>
                                                
                                            </div>
                                        )
                                        
                                       
                                    })}
                                     {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == EAST && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return !this.state.SelectedLabels.filter((r) => r.Direction == EAST)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div key = {i}>
                                            <div style={{margin:3}}
                                        >
                                                <SafeLatexViewComponent 
                                            source = {"$$\\large{"+ r.Label.Name.replaceAll('$','')+ "}$$"} />

                                                </div>
                                            </div>
                                        )
                                       
                                    })}
                                    </Col>
                                </Row> : <div/>}
                                {this.state.SelectedLabels.filter((r) => r.Direction == SOUTH).length ? 
                                <hr/> : <div/>}


                                {this.state.SelectedLabels.filter((r) => r.Direction == SOUTH).length ? 
                                <Row>
                                    <Col xs = {2}>
                                    <LatexViewComponent NoBorder = {true} text = {"SOUTH"}/>
                                    </Col>
                                   
                                    <Col xs = {5}>
                                    {this.state.SelectedLabels.filter((r) => r.Direction == SOUTH)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == SOUTH && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div
                                                id = {"LABEL_S_N"+r.Label.Id}
                                                key = {i}
                                                >
                                                <div style={{margin:3}}

                                                >
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                    {/*<Xarrow
                                                    start={"LABEL_C_N"+r.Label.Id} 
                                                    end={"LABEL_S_N"+r.Label.Id} 
                                                    strokeWidth={1}
                                                    headSize={2}
                                                    startAnchor="auto"
                                                    endAnchor="auto"
                                                    color={"green"}
                                                    path={"straight"}
                                                    />*/}
                                                </div>
                                    ))}


                    {this.state.SelectedLabels.filter((r) => r.Direction == SOUTH)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return !this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == SOUTH && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div key = {i}>
                                                <div style={{margin:3}}>
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{red}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                </div>
                                    ))}
                                    </Col>
                                    <Col xs = {5}>
                                    {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == SOUTH && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return this.state.SelectedLabels.filter((r) => r.Direction == SOUTH)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div
                                            key = {i}
                                            style = {{flexDirection:'row', display:'flex'}}
                                            >
                                            <div style={{margin:3}}
                                            
                                            >   
                                                <SafeLatexViewComponent 
                                            source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />
                                                
                                                </div>
                                                
                                            </div>
                                        )
                                        
                                       
                                    })}
                                     {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == SOUTH && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return !this.state.SelectedLabels.filter((r) => r.Direction == SOUTH)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div key = {i}>
                                            <div style={{margin:3}}
                                        >
                                                <SafeLatexViewComponent 
                                            source = {"$$\\large{"+ r.Label.Name.replaceAll('$','')+ "}$$"} />

                                                </div>
                                            </div>
                                        )
                                       
                                    })}
                                    </Col>
                                </Row> : <div/>}
                                {this.state.SelectedLabels.filter((r) => r.Direction == WEST).length ? 
                                <hr/> : <div/>}


                                {this.state.SelectedLabels.filter((r) => r.Direction == WEST).length
                                ?
                                <Row>
                                    <Col xs = {2}>
                                    <LatexViewComponent NoBorder = {true} text = {"WEST"}/>
                                    </Col>
                                    
                                    <Col xs = {5}>
                                    {this.state.SelectedLabels.filter((r) => r.Direction == WEST)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == WEST && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div
                                                id = {"LABEL_S_N"+r.Label.Id}
                                                key = {i}
                                                >
                                                <div style={{margin:3}}

                                                >
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                    {/*<Xarrow
                                                    start={"LABEL_C_N"+r.Label.Id} 
                                                    end={"LABEL_S_N"+r.Label.Id} 
                                                    strokeWidth={1}
                                                    headSize={2}
                                                    startAnchor="auto"
                                                    endAnchor="auto"
                                                    color={"green"}
                                                    path={"straight"}
                                                    />*/}
                                                </div>
                                    ))}


                    {this.state.SelectedLabels.filter((r) => r.Direction == WEST)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return !this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == WEST && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div key = {i}>
                                                <div style={{margin:3}}>
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{red}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                </div>
                                    ))}
                                    </Col>
                                    <Col xs = {5}>
                                    {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == WEST && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return this.state.SelectedLabels.filter((r) => r.Direction == WEST)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div
                                            key = {i}
                                            style = {{flexDirection:'row', display:'flex'}}
                                            >
                                            <div style={{margin:3}}
                                            
                                            >   
                                                <SafeLatexViewComponent 
                                            source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />
                                                
                                                </div>
                                                
                                            </div>
                                        )
                                        
                                       
                                    })}
                                     {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == WEST && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return !this.state.SelectedLabels.filter((r) => r.Direction == WEST)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div key = {i} >
                                            <div style={{margin:3}}
                                        >
                                                <SafeLatexViewComponent 
                                            source = {"$$\\large{"+ r.Label.Name.replaceAll('$','')+ "}$$"} />

                                                </div>
                                            </div>
                                        )
                                       
                                    })}
                                    </Col>
                                </Row> : <div/>}
                                {this.state.SelectedLabels.filter((r) => r.Direction == CENTER).length ? 
                                <hr/> : <div/>}

                                {this.state.SelectedLabels.filter((r) => r.Direction == CENTER).length ? 
                                <Row>
                                    <Col xs = {2}>
                                    <LatexViewComponent NoBorder = {true} text = {"CENTER"}/>
                                    </Col>
                                    
                                    <Col xs = {5}>
                                    {this.state.SelectedLabels.filter((r) => r.Direction == CENTER)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == CENTER && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div
                                                key = {i}
                                                id = {"LABEL_S_N"+r.Label.Id}
                                                
                                                >
                                                <div style={{margin:3}}

                                                >
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                    {/*<Xarrow
                                                    start={"LABEL_C_N"+r.Label.Id} 
                                                    end={"LABEL_S_N"+r.Label.Id} 
                                                    strokeWidth={1}
                                                    headSize={2}
                                                    startAnchor="auto"
                                                    endAnchor="auto"
                                                    color={"green"}
                                                    path={"straight"}
                                                    />*/}
                                                </div>
                                    ))}


                    {this.state.SelectedLabels.filter((r) => r.Direction == CENTER)
                                     .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                     .filter((sl) => {
                                        return !this.props.Question.ClickableParts[0].Relations
                                        .filter((r) => !r.EB_QuestionId && r.Direction == CENTER && !r.IsDummy)
                                        .map((r) => r.Label.Id).includes(sl.Label.Id)
                                     })
                                    .map((r,i) =>(
                                                <div key = {i}>
                                                <div style={{margin:3}}>
                                                    <SafeLatexViewComponent 
                                                source = {"$$\\color{red}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />

                                                    </div>
                                                </div>
                                    ))}
                                    </Col>
                                    <Col xs = {5}>
                                    {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == CENTER && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return this.state.SelectedLabels.filter((r) => r.Direction == CENTER)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div
                                            key = {i}
                                            style = {{flexDirection:'row', display:'flex'}}
                                            >
                                            <div style={{margin:3}}
                                            
                                            >   
                                                <SafeLatexViewComponent 
                                            source = {"$$\\color{green}{\\large{"+ r.Label.Name.replaceAll('$','')+ "}}$$"} />
                                                
                                                </div>
                                                
                                            </div>
                                        )
                                        
                                       
                                    })}
                                     {this.props.Question.ClickableParts[0].Relations
                                    .filter((r) => !r.EB_QuestionId && r.Direction == CENTER && !r.IsDummy)
                                    .sort((a,b) => a.Label.Id > b.Label.Id ? 1 : -1)
                                    .filter((r) => {
                                        return !this.state.SelectedLabels.filter((r) => r.Direction == CENTER)
                                        .map((sl) => sl.Label.Id).includes(r.Label.Id)
                                    })
                                    .map((r,i) =>{
                                        return(
                                            <div key = {i}>
                                            <div style={{margin:3}}
                                        >
                                                <SafeLatexViewComponent 
                                            source = {"$$\\large{"+ r.Label.Name.replaceAll('$','')+ "}$$"} />

                                                </div>
                                            </div>
                                        )
                                       
                                    })}
                                    </Col>
                                </Row> : <div/>}
                            </Col>
                            
                        </Row>
                        <LineComponent Color = "#99e7ff"/>
                        <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {2}
                        className = "border border-primary"
                        style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center', borderRadius:20,backgroundColor:'#e6faff'}}>
                           <div style = {{flexDirection:'column', display:'flex',alignContent:'center', alignItems:'center',}}>
                           <h5 style = {{color:'#0099cc'}} >
                                Energy Balance {!(this.state.EBLabelsCorrect && this.state.QuestionsCorrect) ? '❌' : '✔️'}
                            </h5>
                           </div>
                        </Col>
                    </Row>
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                                <Col xs = {2}>
                                <h5  className = "text-muted">
                                        Your Energy Balance
                                    </h5>
                                    </Col> 
                                    <Col xs = {4}>
                                   
                                    </Col>     
                                    <Col xs = {6}>
                                    <h5  style = {{color:'#0099cc'}}>
                                       Questions Verification of Correct Labels
                                    </h5>
                                    </Col>                    
                    </Row>
                    <Row  style = {{width:'95%', marginLeft:'2%', marginBottom:'1%'}}>
                        <Col xs = {6}>
                        <div style = {{flexDirection:'row', display:'flex', width:'95%', marginLeft:'2%'}}>
                        <Col xs = {1}>
                        
                        </Col>    
                        
                        {this.state.SelectedLabels.filter((sl) => 
                                [UNSTEADY_FLOW].includes(sl.FlowType)
                            ).length ? 
                            this.state.SelectedLabels.filter((sl) => 
                                [UNSTEADY_FLOW].includes(sl.FlowType)
                            ).map((sl, i) =>(
                                <div style = {{marginLeft: 5}} key = {i}>
                                    <SafeLatexViewComponent source = {"$$\\Large{"+sl.Label.Name.replaceAll('$', '')+"}$$"}/>
                                </div>
                            )):
                                <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{0}$$"}/>
                                </div>}
                            
                            <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{=}$$"}/>
                                </div>
                                {this.state.SelectedLabels.filter((sl) => 
                                [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                            ).length ? 
                            this.state.SelectedLabels.filter((sl) => 
                                [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                            ).map((sl,i) =>(
                                <div key = {i} style = {{flexDirection:'row', display:'flex', marginLeft: 5, borderBottom:0, borderBottomStyle:'solid', borderBottomColor:[INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red"}}>
                                    <SafeLatexViewComponent source = {"$$\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\Large{"+ ([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "+" : "-")+sl.Label.Name.replaceAll('$', '')+"}}$$"}/>
                                </div>
                            )) : 
                                    <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{0}$$"}/>
                                    </div>
                          }
                        </div>
                          <br/>
                        <h5  className = "text-muted">
                                        Possible Energy Balances
                                    </h5>
                        <br/>
                        {this.state.PossibleEBs.map((r, ir) => {
                        let LabelIds = r.map((l) => l.Label.Id)
                        let Selected = (this.state.SelectedLabels.filter((sl) => LabelIds.includes(sl.Label.Id)).length ==  LabelIds.length) && (this.state.SelectedLabels.length == LabelIds.length)

                       if(Selected){
                           return(
                        <div style = {{flexDirection:'row', display:'flex', width:'95%', marginLeft:'2%'}} className = {Selected ? "border border-success" : ""}>
                        <Col xs = {1}>
                        <h5 style = {{color:'#cccccc', textAlign:'center', fontWeight:'bold'}}>{ir+1}</h5>

                        </Col>    
                        
                        {this.state.SelectedLabels.filter((sl) => 
                                [UNSTEADY_FLOW].includes(sl.FlowType)
                            ).length ? 
                            this.state.SelectedLabels.filter((sl) => 
                                [UNSTEADY_FLOW].includes(sl.FlowType)
                            ).map((sl,i) =>(
                                <div style = {{marginLeft: 5}} key = {i}>
                                    <SafeLatexViewComponent source = {"$$\\Large{"+sl.Label.Name.replaceAll('$', '')+"}$$"}/>
                                </div>
                            )):
                                <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{0}$$"}/>
                                </div>}
                            
                            <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{=}$$"}/>
                                </div>
                                {this.state.SelectedLabels.filter((sl) => 
                                [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                            ).length ? 
                            this.state.SelectedLabels.filter((sl) => 
                                [INGOING_FLOW, OUTGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType)
                            ).map((sl,i) =>(
                                <div key = {i} style = {{flexDirection:'row', display:'flex', marginLeft: 5, borderBottom:0, borderBottomStyle:'solid', borderBottomColor:[INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red"}}>
                                    <SafeLatexViewComponent source = {"$$\\color{"+([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "green" : "red")+"}{\\Large{"+ ([INGOING_FLOW, SOURCE_FLOW].includes(sl.FlowType) ? "+" : "-")+sl.Label.Name.replaceAll('$', '')+"}}$$"}/>
                                </div>
                            )) : 
                                    <div style = {{marginLeft: 5}}>
                                    <SafeLatexViewComponent source = {"$$\\Large{0}$$"}/>
                                    </div>
                          }
                          <Col xs = {1}>
                                {!Selected? '' : '✔️'}
                                </Col>
                        </div>)
                       }
                       else{
                        return (
                            <Row key = {ir} style = {{width:'95%', marginLeft:'2%'}} className = {Selected ? "border border-success" : ""}>
                                <Col xs = {1}> 
                                    <h5 style = {{color:'#cccccc', textAlign:'center', fontWeight:'bold'}}>{ir+1}</h5>
                                </Col>
                                <Col xs = {10} style = {{flexDirection:'row', display:'flex'}}>
                                <SafeLatexViewComponent source = {"$$\\Large{0 = }$$"}/>
                                <div  style = {{flexDirection:'row', display:'flex', marginLeft: 5, }}>
                                    <SafeLatexViewComponent source = {"$$\\color{green}{\\Large{"+ r.reduce((a,b) => a += "+" + b.Label.Name.replaceAll('$', '') , "")+"}}$$"}/>
                                </div>
                                </Col>
                                <Col xs = {1}>
                                {!Selected? '' : '✔️'}
                                </Col>
                            </Row>
                        )
                       }
                        
                    })}
                        </Col>
                        <Col xs = {6}>
                            {this.state.SelectedLabels.filter((sl) => 
                            this.props.Question.ClickableParts[0].Relations.filter((r) => !r.EB_QuestionId)
                                .map((r) => r.Label.Id).includes(sl.Label.Id))
                                .map((sl, sli) => {
                                    let Color = "$"
                                    let Last = "}$"
                                    let Word = " (Ingoing)"

                                    if(sl.FlowType == SOURCE_FLOW){
                                        Word = " (Source)"
                                    }

                                    if(sl.FlowType == OUTGOING_FLOW){
                                         Color = "$"
                                         Word = " (Outgoing)"
                                    }

                                    if(sl.FlowType == UNSTEADY_FLOW){
                                        Color = "$"
                                        Last = "$"
                                        Word = " (Unsteady)"

                                    }
                                    return (
                                        <div className = "border border-secondary" key = {sli} 
                                         style = {{width:'95%', marginLeft:'2%', marginBottom:'2%',marginBottom:10,
                                        backgroundColor:'#f2f2f2'}}>
                                            <div style = {{margin:5}}>
                                                <Row style = {{width:'95%', marginLeft:'2%'}}>
                                                <Col xs = {1}> 
                                                    <h5 style = {{color:'#0099cc', textAlign:'center', fontWeight:'bold'}}>{sli+1}</h5>
                                                </Col>
                                                <Col xs = {10}>
                                                <SafeLatexViewComponent source = {Color +"\\Large{"+ sl.Label.Name.replaceAll('$', '')+(Word)+Last}/>
                                                
                                                </Col>
                                                </Row>
                                                <LineComponent Color = "#99e7ff"/>
    
                                                {sl.Questions.map((q,qi) => (
                                                    <div key = {qi}>
                                                        <Row>
                                                            <Col xs = {12}>
                                                            <SafeLatexViewComponent source = {"$$\\large{"+q.Latex.replaceAll('$', '')+"}$$"}/>
    
                                                            </Col>
                                                        </Row>
                                                    <p style = {{color:'#0099cc'}}>Your answer: </p>
    
                                                        <Row style = {{width:'95%', marginLeft:'2%'}}>
                                                        <Col xs = {1}>
                                                        {!sl.AnswersStatus[qi] ? '❌' : '✔️'}
                                                        </Col>
                                                        <Col xs = {11}>
                                                        <SafeLatexViewComponent 
                                                            source = {"$$\\color{" + (!sl.AnswersStatus[qi] ? 'red' : 'green')+"}{\\large{"+ sl.Answers[qi].List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}}$$"}
                                                        />
                                                        </Col>
                                                    </Row>
                                                    <LineComponent Color = "#e6e6e6"/>
                                                    <h5>
                                                        <Badge color="primary" style = {{cursor:'pointer'}} onClick = {() => {
                                                            let ShowPossibleAnswers = this.state.ShowPossibleAnswers || []

                                                            if(ShowPossibleAnswers.map((qq) => qq.Id).includes(q.Id))
                                                            {
                                                                ShowPossibleAnswers = ShowPossibleAnswers.filter((qq) => qq.Id != q.Id)

                                                                this.setState({
                                                                    ShowPossibleAnswers: ShowPossibleAnswers
                                                                })

                                                                return
                                                            }

                                                            ShowPossibleAnswers.push(q)

                                                            this.setState({
                                                                ShowPossibleAnswers: ShowPossibleAnswers
                                                            })
                                                        
                                                    }}>
                                                            Possible answers
                                                        </Badge>
                                                    </h5>
    
                                                    {this.state.ShowPossibleAnswers.map((qq) => qq.Id).includes(q.Id) ?
                                                    <Row style = {{width:'95%', marginLeft:'2%'}}>
                                                        {this.props.Question.Questions.filter((qq) => qq.Id == q.Id)[0].Answers.map((a,ai) => (
                                                            <Row key = {ai} style = {{width:'95%', marginLeft:'2%'}} key = {ai} className = {sl.AnswersIndex[qi] == ai ? "border border-success" : ""}>
                                                             <Col xs = {1}> 
                                                                <h5 style = {{color:sl.AnswersIndex[qi] == ai ?'green' : '#cccccc', textAlign:'center', fontWeight:'bold'}}>{ai+1}</h5>
                                                            </Col>
                                                            
                                                            <Col xs = {10}>
                                                            <SafeLatexViewComponent 
                                                            source = {"$\\large{"+ ((!q.Ingoing && (sl.FlowType == INGOING_FLOW) || (q.Ingoing && (sl.FlowType == OUTGOING_FLOW)))? "-(" : "(")+ a.AnswerElements.sort((c,d) => c.Id > d.Id ? 1 : -1).reduce((a,b) => a += ' ' + (b.TextPresentation || (b.Value == '*' ? '\\cdot': b.Value)), '') + ")}$"}
                                                        />
                                                            </Col>
                                                            </Row>
                                                        ))}
                                                   
                                                    </Row> : <div/>}
                                                    {(1+qi != sl.Questions.length ) 
                                                    && this.state.ShowPossibleAnswers.map((a) => a.Label.Id).includes(sl.Label.Id)
                                                    ?  <LineComponent Color = "#99e7ff"/>  : <div/>}
    
                                                    </div>
                                                ) )}
                                            </div>
                                        </div>
                                    )
                                })}
                        </Col>
                    </Row>
                    <br/>
                   
                    
                    
                </div> : <div/>}

            </div> }
            </div>
        )
    }

   SetAnswerModal(){
       if(!this.state.ShowAnswerModal){
           return
       }

       let SelectedAnswer = this.state.SelectedAnswer
       let SelectedLabelIndex = this.state.SelectedLabelIndex
       let SelectedAnswerIndex = this.state.SelectedAnswerIndex

       return(
           <ModalComponent 
           isOpen = {this.state.ShowAnswerModal} 
           ModalHeader ="Set answer via keyboard"
           NoActionLog = {true}
           size = "xl"
           >
               <Row style = {{width:'95%', marginLeft:'2%',}}>
                   <Col xs = {12}>
                    <SafeLatexViewComponent source = {"$\\Large{"+SelectedAnswer.Latex.replaceAll('$','')+ "}$"}/>
                   </Col>
               </Row>
               {this.state.SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex] ? <br/> : <div/>}
               {this.state.SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex] ? 
                            <Row style = {{width:'95%', marginLeft:'2%',
                            borderBottom:1,
                            borderBottomColor: this.state.KeyboardIn ? "green":'#e6e6e6',
                            borderBottomStyle:'solid',
                            height:60}}>
                                <Col xs = {11}>
                                    <SafeLatexViewComponent 
                                        source = {"$\\large{"+ this.state.SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                    />
                                </Col>
                                <Col xs = {1}>
                             {!CheckKeyboardAnswer(this.state.SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex])? '❌' : '✔️'}
                             </Col>
                            </Row> : <div/>}
                <br/>
               <div 
               style = {{
                   borderTop:1, 
                   borderLeft:1, 
                   borderRight:3, 
                   borderBottom:3, 
                   borderStyle:'solid',
                   borderColor:this.state.KeyboardIn && false ? "#b3ecff" : "#cccccc",
                   borderRadius:10
               }}

               onMouseEnter = {() => {
                   this.setState({
                       KeyboardIn: true
                   })
               }}

               onMouseLeave = {() => {
                    this.setState({
                        KeyboardIn: false
                    })
                }}
               >
                <div style = {{height:3, borderBottom:0, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:10}}/>
               <Row style = {{width:'95%', marginLeft:'2%'}}>
                    {[...this.state.SelectedAnswer.Keyboard.NumericKeys.map((k) => ({...k, Type:NUMERIC_BLOCK})),
                        ...this.state.SelectedAnswer.Keyboard.VariableKeys.map((k) => ({...k, Type:VARIABLE_BLOCK}))]
                        .sort((a, b) => (a.Order >= b.Order) ? 1 : -1).map((kk, i) => {
                        return(
                            <Col
                            key = {i}
                            style = {{marginLeft:5, marginBottom:5,
                                flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                                backgroundColor:'#e6e6e6', borderRadius:5
                            }}

                            onClick = {() =>{
                                

                                if(kk.Type == VARIABLE_BLOCK){
                                   

                                    this.setState({
                                        ShowVarModal:true,
                                        SelectedVariableKey: kk.VariableKey
                                    })
                                    return
                                }

                                 
                                let QuestionAnswers = this.state.QuestionAnswers
                                let SelectedLabels = this.state.SelectedLabels
                                let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                                let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                                
                                if(Last && Last.IsNVKey && !(Last.IsInteger && kk.NumericKey.IsInteger)){
                                    Answer.List.push({
                                        IsLatex:false,
                                        code:'*',
                                        char:'*',
                                        Left: Answer.Left,
                                        Right: Answer.Right,
                                        RightBracket: Answer.RightBracket,
                                        LeftBracket: Answer.LeftBracket,
                                    })

                                    Answer.Left = true
                                    Answer.Right = false
                                    Answer.RightBracket = true
                                    Answer.LeftBracket = false
                                    Answer.IsInteger = false

                                    this.setState({
                                        SelectedLabels:SelectedLabels,
                                       
                                    })
                                }

                                Answer.List.push({
                                    IsLatex:true,
                                    code:kk.NumericKey.TextPresentation,
                                    NumericKeyId:kk.Id,
                                    Id: kk.NumericKey.Id,
                                    char: kk.NumericKey.IsInteger ? kk.NumericKey.TextPresentation : kk.KeySimpleForm,
                                    Left: Answer.Left,
                                    Right: Answer.Right,
                                    RightBracket: Answer.RightBracket,
                                    LeftBracket: Answer.LeftBracket,
                                    IsInteger: kk.NumericKey.IsInteger,
                                    IsImage: true,
                                    IsNVKey: true,
                                    ImageURL: kk.NumericKey.URL,
                                    ImageWidth: kk.NumericKey.Width,
                                    ImageHeight: kk.NumericKey.Height,
                                    ReducedSize: !(kk.NumericKey.TextPresentation.includes('_') || kk.NumericKey.TextPresentation.includes('^') || kk.NumericKey.TextPresentation.includes("'"))

                                })

                                

                                Answer.Right = true
                                Answer.Left = false
                                Answer.RightBracket = false
                                Answer.LeftBracket = true

                                this.setState({
                                    //SelectedAnswer:SelectedAnswer,
                                    SelectedLabels:SelectedLabels
                                })
                            }}

                            className = "border border-secondary"

                            >
                                {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{' + (kk.NumericKey || kk.VariableKey).TextPresentation + '}'}
                                                NoBorder = {true}
                                            />}
                            </Col>
                        )
                    })
                    }
                    </Row> 
                    {this.state.SelectedVariableKey ? 
                    <Row style = {{width:'95%', marginLeft:'2%'}}>
                        {this.state.SelectedVariableKey.VImages.map((im, im_i) => {
                return(
                    <Col
                    key= {im_i}
                    style = {{marginLeft:5, marginBottom:5,
                        flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                        backgroundColor:'#f2ffcc', borderRadius:5
                    }}
                    className = "border border-secondary"

                    onClick = {() =>{
                        let QuestionAnswers = this.state.QuestionAnswers
                        let SelectedLabels = this.state.SelectedLabels
                        let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                        let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                               
                                        if(Last && Last.IsNVKey){
                                                    Answer.List.push({
                                                        IsLatex:false,
                                                        code:'*',
                                                        char:'*',
                                                        Left: Answer.Left,
                                                        Right: Answer.Right,
                                                        RightBracket: Answer.RightBracket,
                                                        LeftBracket: Answer.LeftBracket,
                                                    })
        
                                                    Answer.Left = true
                                                    Answer.Right = false
                                                    Answer.RightBracket = true
                                                    Answer.LeftBracket = false
                                                    Answer.IsInteger = false
        
                                                    this.setState({
                                                        Answer:Answer,
                                                        SelectedLabels:SelectedLabels

                                                    })
                                                }
    
                                        Answer.List.push({
                                            IsImage:true,
                                            code: SelectedAnswer.Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].Image.TextPresentation,//this.state.SelectedVariableKey.TextPresentation,
                                            Id: this.state.SelectedVariableKey.Id,
                                            IsInteger: false,//this.state.SelectedVariableKey.IsInteger,
                                            char: SelectedAnswer.Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].ReplacementCharacter,
                                            ImageId:-1,
                                            ImageURL:im.URL,
                                            ImageWidth: im.Width,
                                            ImageHeight: im.Height,
                                            Left: Answer.Left,
                                            Right: Answer.Right,
                                            RightBracket: Answer.RightBracket,
                                            LeftBracket: Answer.LeftBracket,
                                            ReducedSize: false,
                                            IsNVKey: true,
                                            VariableImageId: SelectedAnswer.Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].Id,
                                        })
    
                                        Answer.Right = true
                                        Answer.Left = false
                                        Answer.RightBracket = false
                                        Answer.LeftBracket = true
    
                                        this.setState({
                                            SelectedVariableKey:undefined,
                                            SelectedLabels:SelectedLabels
                                        })
                    }}
                    >
                        {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{' + (im).TextPresentation + '}'}
                                                NoBorder = {true}
                                            />}
                    </Col>

                        )
                    })}
                    </Row>
                    
                    : <div/>}
                    <Row style = {{width:'95%', marginLeft:'2%', marginTop:10}}>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#e6faff', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() => {
                                
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                          
                            if(Answer.Left)
                            {
                                return 
                            }
                            if(!Answer.List.length){
                                return
                            }

                            Answer.List.push({
                                IsLatex:false,
                                code:'+',
                                char:'+',
                                Left: Answer.Left,
                                Right: Answer.Right,
                                RightBracket: Answer.RightBracket,
                                LeftBracket: Answer.LeftBracket,
                                Special: false
                            })

                            Answer.Right = false
                            Answer.Left = true
                            Answer.RightBracket = true
                            Answer.LeftBracket = false
                            Answer.IsInteger = false

                            this.setState({
                                SelectedLabels:SelectedLabels
                            })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{+}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#e6faff', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() => {

                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(Answer.Left)
                            {

                                if(Answer.List.length && Answer.List.slice(-1)[0].char != '=' && Answer.List.slice(-1)[0].char == '-')
                                {
                                    return
                                } 
                            }

                            Answer.List.push({
                                IsLatex:false,
                                code:'-',
                                char:'-',
                                Left: Answer.Left,
                                Right: Answer.Right,
                                RightBracket: Answer.RightBracket,
                                LeftBracket: Answer.LeftBracket,
                            })

                            Answer.Left = true
                            Answer.Right = false
                            Answer.RightBracket = true
                            Answer.LeftBracket = false
                            Answer.IsInteger = false

                            this.setState({
                                SelectedLabels:SelectedLabels
                                
                            })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{-}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#e6faff', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() => {
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(Answer.Left)
                            {
                                return 
                            }

                            if(!Answer.List.length){
                                return
                            }

                            Answer.List.push({
                                IsLatex:false,
                                code:'*',
                                char:'*',
                                Left: Answer.Left,
                                Right: Answer.Right,
                                RightBracket: Answer.RightBracket,
                                LeftBracket: Answer.LeftBracket,
                            })

                            Answer.Left = true
                            Answer.Right = false
                            Answer.RightBracket = true
                            Answer.LeftBracket = false
                            Answer.IsInteger = false

                            this.setState({
                                SelectedLabels:SelectedLabels,
                               
                            })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{*}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#e6faff', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() => {
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(!Answer.RightBracket && Answer.List.length && Answer.List.slice(-1)[0].code != '(')
                            {
                                return 
                            }

                            Answer.List.push({
                                IsLatex:false,
                                code:'(',
                                char:'(',
                                Left: Answer.Left,
                                Right: Answer.Right,
                                RightBracket:  Answer.RightBracket,
                                LeftBracket:  Answer.LeftBracket,
                            })

                            Answer.echoNumber =
                            Answer.echoNumber + 1
                            
                            Answer.Left = true
                            Answer.Right = false
                            Answer.IsInteger = false

                            this.setState({
                                SelectedLabels:SelectedLabels,
                               
                            })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{(}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#e6faff', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() => {
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(!Answer.LeftBracket  && Answer.List.length)
                            {
                                return 
                            }

                            if(Answer.echoNumber == 0)
                            {
                                return
                            }

                            Answer.List.push({
                                IsLatex:false,
                                code:')',
                                char:')',
                                Left: Answer.Left,
                                Right: Answer.Right,
                                RightBracket: Answer.RightBracket,
                                LeftBracket:Answer.LeftBracket,
                            })

                            Answer.echoNumber =
                            Answer.echoNumber - 1
                            
                            Answer.Left = false
                            Answer.Right = true
                            Answer.IsInteger = false

                            this.setState({
                                SelectedLabels:SelectedLabels
                            })
                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{)}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#ffe6e6', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() =>{
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(!Answer.List.length)
                                                {
                                                    return
                                                }

                                                Answer.Left = Last.Left
                                                Answer.LeftBracket = Last.LeftBracket
                                                Answer.Right = Last.Right
                                                Answer.RightBracket = Last.RightBracket
                                                Answer.IsInteger = Last.IsInteger

                                                let echoNumber = Answer.echoNumber

                                                if(Last.char == ')'){
                                                    echoNumber = echoNumber + 1
                                                }

                                                if(Last.char == '('){
                                                    echoNumber = echoNumber - 1
                                                }

                                                Answer.echoNumber = echoNumber

                                                Answer.List.pop()

                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{⇐}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                        <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#ffe6e6', borderRadius:5
                        }}
                        className = "border border-secondary"
                        onClick = {() =>{
                            let QuestionAnswers = this.state.QuestionAnswers
                            let SelectedLabels = this.state.SelectedLabels
                            let Answer = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                            let Last = SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex].List.slice(-1)[0]

                            if(!Answer.List.length)
                                                {
                                                    return
                                                }

                                                Answer.echoNumber = 0

                                                Answer.List = []

                                                this.setState({
                                                    SelectedLabels:SelectedLabels
                                                })
                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'Clear'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                    </Row>
                <div style = {{height:3, borderBottom:1, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:3, marginTop:5}}/>

                    </div>
                    <hr/>
                    <Row>
                        <Col xs = {11}>
                        </Col>
                        <Col xs = {1}>
                            <h5>
                                <Badge 
                                color = "success" 
                                style = {{cursor:'pointer'}}
                                onClick = {() => {
                                    let Answer = this.state.SelectedLabels[SelectedLabelIndex].Answers[SelectedAnswerIndex]
                                    
                                    if(!CheckKeyboardAnswer(Answer, false)){
                                        alert("Please enter a valid answer!")

                                        return
                                    }

                                    let Question = this.state.SelectedLabels[SelectedLabelIndex].Questions[SelectedAnswerIndex]
                                    /*let OtherLabels = this.state.SelectedLabels.filter((sl) => sl.Questions.filter((slq) => slq.Id == Question.Id).length)

                                    console.log("OtherLabels")
                                    console.log(OtherLabels)

                                    for(let Label of OtherLabels){
                                        let LQs = Label.Questions.map((q,i) => ({
                                            Index:i,
                                            Id: q.Id
                                        })).filter((a) => a.Id == Question.Id).map((b) => b.Index)

                                        console.log("LQs")
                                        console.log(LQs)

                                        for(let Index of LQs){
                                            Label.Answers[Index] = Answer
                                        }

                                    }*/

                                    this.setState({
                                        ShowAnswerModal: false
                                    })
                                }}
                                > 
                                Ok
                                </Badge>
                            </h5>
                        </Col>
                    </Row>

           </ModalComponent>
       )
   }

   AddBoundryConditionModal(){
    if(!this.state.ShowAddBoundryCondition){
        return
    }

    let Answer = this.state.NewBoundryCondition
    let Keyboard = this.props.Question.BoundryConditionKeyboard
    
    return(
        <ModalComponent 
        isOpen = {this.state.ShowAddBoundryCondition} 
        ModalHeader ="Add boundary condition via keyboard"
        NoActionLog = {true}
        size = "xl"
        >
            <Row style = {{width:'100%'}}>
                <Col xs = {12}>
                 <SafeLatexViewComponent source = {"Add boundary condition via keyboard"}/>
                </Col>
            </Row>
            
                         <Row style = {{
                         width:'95%', marginLeft:'2%',
                         borderBottom:1,
                         borderBottomColor: this.state.KeyboardIn ? "green":'#e6e6e6',
                         borderBottomStyle:'solid',
                         height:60}}>
                             <Col xs = {11}>
                                 <SafeLatexViewComponent 
                                     source = {"$\\large{"+ Answer.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                 />
                             </Col>
                             <Col xs = {1}>
                             {!CheckKeyboardAnswer(Answer, true)? '❌' : '✔️'}
                             </Col>
                         </Row>
            <br/>
            <div 
               style = {{
                   borderTop:1, 
                   borderLeft:1, 
                   borderRight:3, 
                   borderBottom:3, 
                   borderStyle:'solid',
                   borderColor:this.state.KeyboardIn && false ? "#b3ecff" : "#cccccc",
                   borderRadius:10
               }}

               onMouseEnter = {() => {
                   this.setState({
                       KeyboardIn: true
                   })
               }}

               onMouseLeave = {() => {
                    this.setState({
                        KeyboardIn: false
                    })
                }}
               >
                <div style = {{height:3, borderBottom:0, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:10}}/>
            <Row style = {{width:'95%', marginLeft:'2%'}}>
                 {[...Keyboard.NumericKeys.map((k) => ({...k, Type:NUMERIC_BLOCK})),
                     ...Keyboard.VariableKeys.map((k) => ({...k, Type:VARIABLE_BLOCK}))]
                     .sort((a, b) => (a.Order >= b.Order) ? 1 : -1).map((kk, i) => {
                     return(
                         <Col
                         key = {i}
                         style = {{marginLeft:5, marginBottom:5,
                             flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                             backgroundColor:'#e6e6e6', borderRadius:5
                         }}

                         onClick = {() =>{
                             

                             if(kk.Type == VARIABLE_BLOCK){
                                

                                 this.setState({
                                     ShowVarModal:true,
                                     SelectedVariableKey: kk.VariableKey
                                 })
                                 return
                             }

                              
                             let Last = Answer.List.slice(-1)[0]

                             
                             if(Last && Last.IsNVKey && !(Last.IsInteger && kk.NumericKey.IsInteger)){
                                 Answer.List.push({
                                     IsLatex:false,
                                     code:'*',
                                     char:'*',
                                     Left: Answer.Left,
                                     Right: Answer.Right,
                                     RightBracket: Answer.RightBracket,
                                     LeftBracket: Answer.LeftBracket,
                                 })

                                 Answer.Left = true
                                 Answer.Right = false
                                 Answer.RightBracket = true
                                 Answer.LeftBracket = false
                                 Answer.IsInteger = false

                                 this.setState({
                                     NewBoundryCondition:Answer,
                                    
                                 })
                             }

                             Answer.List.push({
                                 IsLatex:true,
                                 code:kk.NumericKey.TextPresentation,
                                 NumericKeyId:kk.NumericKey.Id,
                                 Id: kk.NumericKey.Id,
                                 char: kk.NumericKey.IsInteger ? kk.NumericKey.TextPresentation : kk.KeySimpleForm,
                                 Left: Answer.Left,
                                 Right: Answer.Right,
                                 RightBracket: Answer.RightBracket,
                                 LeftBracket: Answer.LeftBracket,
                                 IsInteger: kk.NumericKey.IsInteger,
                                 IsImage: true,
                                 IsNVKey: true,
                                 ImageURL: kk.NumericKey.URL,
                                 ImageWidth: kk.NumericKey.Width,
                                 ImageHeight: kk.NumericKey.Height,
                                 ReducedSize: !(kk.NumericKey.TextPresentation.includes('_') || kk.NumericKey.TextPresentation.includes('^') || kk.NumericKey.TextPresentation.includes("'"))

                             })

                             

                             Answer.Right = true
                             Answer.Left = false
                             Answer.RightBracket = false
                             Answer.LeftBracket = true

                             this.setState({
                                 //SelectedAnswer:SelectedAnswer,
                                 NewBoundryCondition:Answer,
                                })
                         }}

                         className = "border border-secondary"

                         >
                             {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{' + (kk.NumericKey || kk.VariableKey).TextPresentation + '}'}
                                             NoBorder = {true}
                                         />}
                         </Col>
                     )
                 })
                 }
                 </Row> 
                 {this.state.SelectedVariableKey ? 
                 <Row style = {{width:'95%', marginLeft:'2%'}}>
                     {this.state.SelectedVariableKey.VImages.map((im, im_i) => {
             return(
                 <Col
                 key= {im_i}
                 style = {{marginLeft:5, marginBottom:5,
                     flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                     backgroundColor:'#f2ffcc', borderRadius:5
                 }}
                 className = "border border-secondary"

                 onClick = {() =>{
                     let Last =Answer.List.slice(-1)[0]

                            
                                     if(Last && Last.IsNVKey){
                                                 Answer.List.push({
                                                     IsLatex:false,
                                                     code:'*',
                                                     char:'*',
                                                     Left: Answer.Left,
                                                     Right: Answer.Right,
                                                     RightBracket: Answer.RightBracket,
                                                     LeftBracket: Answer.LeftBracket,
                                                 })
     
                                                 Answer.Left = true
                                                 Answer.Right = false
                                                 Answer.RightBracket = true
                                                 Answer.LeftBracket = false
                                                 Answer.IsInteger = false
     
                                                 this.setState({
                                                     Answer:Answer
                                                 })
                                             }
 
                                     Answer.List.push({
                                         IsImage:true,
                                         code: Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].Image.TextPresentation,//this.state.SelectedVariableKey.TextPresentation,
                                         Id: this.state.SelectedVariableKey.Id,
                                         IsInteger: false,//this.state.SelectedVariableKey.IsInteger,
                                         char: Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].ReplacementCharacter,
                                         ImageId:-1,
                                         ImageURL:im.URL,
                                         ImageWidth: im.Width,
                                         ImageHeight: im.Height,
                                         Left: Answer.Left,
                                         Right: Answer.Right,
                                         RightBracket: Answer.RightBracket,
                                         LeftBracket: Answer.LeftBracket,
                                         ReducedSize: false,
                                         IsNVKey: true,
                                         VariableImageId: im.Id,
                                     })
 
                                     Answer.Right = true
                                     Answer.Left = false
                                     Answer.RightBracket = false
                                     Answer.LeftBracket = true
 
                                     this.setState({
                                         SelectedVariableKey:undefined,
                                         NewBoundryCondition:Answer,
                                        })
                 }}
                 >
                     {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{' + (im).TextPresentation + '}'}
                                             NoBorder = {true}
                                         />}
                 </Col>

                     )
                 })}
                 </Row>
                 
                 : <div/>}
                 <Row style = {{width:'95%', marginLeft:'2%', marginTop:10}}>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                             
                         
                         let Last =Answer.List.slice(-1)[0]

                       
                         if(Answer.Left)
                         {
                             return 
                         }
                         if(!Answer.List.length){
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'+',
                             char:'+',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                             Special: false
                         })

                         Answer.Right = false
                         Answer.Left = true
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{+}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                        let Last = Answer.List.slice(-1)[0]

                         if(Answer.Left)
                         {

                             if(Answer.List.length && Answer.List.slice(-1)[0].char != '=' && Answer.List.slice(-1)[0].char == '-')
                             {
                                 return
                             } 
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'-',
                             char:'-',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                         })

                         Answer.Left = true
                         Answer.Right = false
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{-}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(Answer.Left)
                         {
                             return 
                         }

                         if(!Answer.List.length){
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'*',
                             char:'*',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                         })

                         Answer.Left = true
                         Answer.Right = false
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer,
                            
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{*}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.RightBracket && Answer.List.length && Answer.List.slice(-1)[0].code != '(')
                         {
                             return 
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'(',
                             char:'(',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket:  Answer.RightBracket,
                             LeftBracket:  Answer.LeftBracket,
                         })

                         Answer.echoNumber =
                         Answer.echoNumber + 1
                         
                         Answer.Left = true
                         Answer.Right = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer,
                            
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{(}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.LeftBracket  && Answer.List.length)
                         {
                             return 
                         }

                         if(Answer.echoNumber == 0)
                         {
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:')',
                             char:')',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket:Answer.LeftBracket,
                         })

                         Answer.echoNumber =
                         Answer.echoNumber - 1
                         
                         Answer.Left = false
                         Answer.Right = true
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{)}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#ffe6e6'
                        }}
                        className = "border border-secondary"
                        onClick = {() =>{
                            

                                                if(Answer.Left || !Answer.List.length){
                                                    return
                                                }

                                                Answer.List.push({
                                                    IsLatex:false,
                                                    code:'=',
                                                    char:'=',
                                                    Left: Answer.Left,
                                                    Right: Answer.Right,
                                                    RightBracket: Answer.RightBracket,
                                                    LeftBracket:Answer.LeftBracket,
                                                })

                                            
                                                Answer.Left = true
                                                Answer.Right = false
                                                Answer.IsInteger = false

                                                this.setState({
                                                    NewBoundryCondition:Answer
                                                })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{=}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#ffe6e6'
                     }}
                     className = "border border-secondary"
                     onClick = {() =>{
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.List.length)
                                             {
                                                 return
                                             }

                                             Answer.Left = Last.Left
                                             Answer.LeftBracket = Last.LeftBracket
                                             Answer.Right = Last.Right
                                             Answer.RightBracket = Last.RightBracket
                                             Answer.IsInteger = Last.IsInteger

                                             let echoNumber = Answer.echoNumber

                                             if(Last.char == ')'){
                                                 echoNumber = echoNumber + 1
                                             }

                                             if(Last.char == '('){
                                                 echoNumber = echoNumber - 1
                                             }

                                             Answer.echoNumber = echoNumber

                                             Answer.List.pop()

                                             this.setState({
                                                 NewBoundryCondition:Answer
                                             })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{⇐}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#ffe6e6'
                     }}
                     className = "border border-secondary"
                     onClick = {() =>{
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.List.length)
                                             {
                                                 return
                                             }

                                             Answer.echoNumber = 0

                                             Answer.List = []

                                             this.setState({
                                                 NewBoundryCondition:Answer
                                             })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'Clear'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                 </Row>
                 <div style = {{height:3, borderBottom:1, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:3, marginTop:5}}/>

                 </div>
                 <hr/>
                 <Row>
                     <Col xs = {10}>
                     </Col>
                     <Col xs = {1}>
                         <h5>
                             <Badge 
                             color = "success" 
                             style = {{cursor:'pointer'}}
                             onClick = {() => {
                                if(!CheckKeyboardAnswer(Answer, true))
                                {
                                    alert("Please enter a valid answer!")
                                    return
                                }

                                let BoundryConditions = this.state.BoundryConditions
                                BoundryConditions.push(Answer)

                                this.setState({
                                    BoundryConditions:BoundryConditions,
                                    ShowAddBoundryCondition: false,
                                     NewBoundryCondition:{
                                         List:[]
                                     }
                                })
                             }}
                             > 
                             Add
                             </Badge>
                         </h5>
                     </Col>
                     <Col xs = {1}>
                         <h5>
                             <Badge 
                             color = "danger" 
                             style = {{cursor:'pointer'}}
                             onClick = {() => {
                                 this.setState({
                                     ShowAddBoundryCondition: false,
                                     NewBoundryCondition:{
                                         List:[]
                                     }
                                 })
                             }}
                             > 
                             Close
                             </Badge>
                         </h5>
                     </Col>
                 </Row>

        </ModalComponent>
    )
}

EditBoundryConditionModal(){
    if(!this.state.ShowEditBoundryCondition){
        return
    }

    let OldAnswer = this.state.BoundryConditions[this.state.SelectedAnswerIndex]
    let Answer = this.state.NewBoundryCondition
    let Keyboard = this.props.Question.BoundryConditionKeyboard
    
    return(
        <ModalComponent 
        isOpen = {this.state.ShowEditBoundryCondition} 
        ModalHeader ="Edit boundry condition via keyboard"
        NoActionLog = {true}
        size = "xl"
        >
            <Row style = {{width:'100%'}}>
                <Col xs = {12}>
                 <SafeLatexViewComponent source = {"Edit boundry condition via keyboard"}/>
                </Col>
            </Row>
                <Row style = {{width:'100%',
                         height:60}}>
                             <Col xs = {11}>
                                 <SafeLatexViewComponent 
                                     source = {"OLD = $\\large{"+ OldAnswer.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                 />
                             </Col>
                           
                         </Row>
                         <hr/>
            
                         <Row style = {{
                         width:'95%', marginLeft:'2%',
                         borderBottom:1,
                         borderBottomColor: this.state.KeyboardIn ? "green":'#e6e6e6',
                         borderBottomStyle:'solid',
                         height:60}}>
                             <Col xs = {11}>
                                 <SafeLatexViewComponent 
                                     source = {"NEW = $\\large{ "+ Answer.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')+ "}$"}
                                 />
                             </Col>
                             <Col xs = {1}>
                             {!CheckKeyboardAnswer(Answer, true)? '❌' : '✔️'}
                             </Col>
                         </Row>
            <br/>
            <div 
               style = {{
                   borderTop:1, 
                   borderLeft:1, 
                   borderRight:3, 
                   borderBottom:3, 
                   borderStyle:'solid',
                   borderColor:this.state.KeyboardIn && false ? "#b3ecff" : "#cccccc",
                   borderRadius:10
               }}

               onMouseEnter = {() => {
                   this.setState({
                       KeyboardIn: true
                   })
               }}

               onMouseLeave = {() => {
                    this.setState({
                        KeyboardIn: false
                    })
                }}
               >
                <div style = {{height:3, borderBottom:0, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:10}}/>
            <Row style = {{width:'95%', marginLeft:'2%'}}>
                 {[...Keyboard.NumericKeys.map((k) => ({...k, Type:NUMERIC_BLOCK})),
                     ...Keyboard.VariableKeys.map((k) => ({...k, Type:VARIABLE_BLOCK}))]
                     .sort((a, b) => (a.Order >= b.Order) ? 1 : -1).map((kk, i) => {
                     return(
                         <Col
                         key = {i}
                         style = {{marginLeft:5, marginBottom:5,
                             flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                             backgroundColor:'#e6e6e6', borderRadius:5
                         }}

                         onClick = {() =>{
                             

                             if(kk.Type == VARIABLE_BLOCK){
                                

                                 this.setState({
                                     ShowVarModal:true,
                                     SelectedVariableKey: kk.VariableKey
                                 })
                                 return
                             }

                              
                             let Last = Answer.List.slice(-1)[0]

                             
                             if(Last && Last.IsNVKey && !(Last.IsInteger && kk.NumericKey.IsInteger)){
                                 Answer.List.push({
                                     IsLatex:false,
                                     code:'*',
                                     char:'*',
                                     Left: Answer.Left,
                                     Right: Answer.Right,
                                     RightBracket: Answer.RightBracket,
                                     LeftBracket: Answer.LeftBracket,
                                 })

                                 Answer.Left = true
                                 Answer.Right = false
                                 Answer.RightBracket = true
                                 Answer.LeftBracket = false
                                 Answer.IsInteger = false

                                 this.setState({
                                     NewBoundryCondition:Answer,
                                    
                                 })
                             }

                             Answer.List.push({
                                 IsLatex:true,
                                 code:kk.NumericKey.TextPresentation,
                                 NumericKeyId:kk.NumericKey.Id,
                                 Id: kk.NumericKey.Id,
                                 char: kk.NumericKey.IsInteger ? kk.NumericKey.TextPresentation : kk.KeySimpleForm,
                                 Left: Answer.Left,
                                 Right: Answer.Right,
                                 RightBracket: Answer.RightBracket,
                                 LeftBracket: Answer.LeftBracket,
                                 IsInteger: kk.NumericKey.IsInteger,
                                 IsImage: true,
                                 IsNVKey: true,
                                 ImageURL: kk.NumericKey.URL,
                                 ImageWidth: kk.NumericKey.Width,
                                 ImageHeight: kk.NumericKey.Height,
                                 ReducedSize: !(kk.NumericKey.TextPresentation.includes('_') || kk.NumericKey.TextPresentation.includes('^') || kk.NumericKey.TextPresentation.includes("'"))

                             })

                             

                             Answer.Right = true
                             Answer.Left = false
                             Answer.RightBracket = false
                             Answer.LeftBracket = true

                             this.setState({
                                 //SelectedAnswer:SelectedAnswer,
                                 NewBoundryCondition:Answer,
                                })
                         }}

                         className = "border border-secondary"

                         >
                             {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{' + (kk.NumericKey || kk.VariableKey).TextPresentation + '}'}
                                             NoBorder = {true}
                                         />}
                         </Col>
                     )
                 })
                 }
                 </Row> 
                 {this.state.SelectedVariableKey ? 
                 <Row style = {{width:'95%', marginLeft:'2%'}}>
                     {this.state.SelectedVariableKey.VImages.map((im, im_i) => {
             return(
                 <Col
                 key= {im_i}
                 style = {{marginLeft:5, marginBottom:5,
                     flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                     backgroundColor:'#f2ffcc', borderRadius:5
                 }}
                 className = "border border-secondary"

                 onClick = {() =>{
                     let Last =Answer.List.slice(-1)[0]

                            
                                     if(Last && Last.IsNVKey){
                                                 Answer.List.push({
                                                     IsLatex:false,
                                                     code:'*',
                                                     char:'*',
                                                     Left: Answer.Left,
                                                     Right: Answer.Right,
                                                     RightBracket: Answer.RightBracket,
                                                     LeftBracket: Answer.LeftBracket,
                                                 })
     
                                                 Answer.Left = true
                                                 Answer.Right = false
                                                 Answer.RightBracket = true
                                                 Answer.LeftBracket = false
                                                 Answer.IsInteger = false
     
                                                 this.setState({
                                                     Answer:Answer
                                                 })
                                             }
 
                                     Answer.List.push({
                                         IsImage:true,
                                         code: Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].Image.TextPresentation,//this.state.SelectedVariableKey.TextPresentation,
                                         Id: this.state.SelectedVariableKey.Id,
                                         IsInteger: false,//this.state.SelectedVariableKey.IsInteger,
                                         char: Keyboard.VariableKeyImages.filter((imm) => imm.ImageId == im.Id)[0].ReplacementCharacter,
                                         ImageId:-1,
                                         ImageURL:im.URL,
                                         ImageWidth: im.Width,
                                         ImageHeight: im.Height,
                                         Left: Answer.Left,
                                         Right: Answer.Right,
                                         RightBracket: Answer.RightBracket,
                                         LeftBracket: Answer.LeftBracket,
                                         ReducedSize: false,
                                         IsNVKey: true,
                                         VariableImageId: im.Id,
                                     })
 
                                     Answer.Right = true
                                     Answer.Left = false
                                     Answer.RightBracket = false
                                     Answer.LeftBracket = true
 
                                     this.setState({
                                         SelectedVariableKey:undefined,
                                         NewBoundryCondition:Answer,
                                        })
                 }}
                 >
                     {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{' + (im).TextPresentation + '}'}
                                             NoBorder = {true}
                                         />}
                 </Col>

                     )
                 })}
                 </Row>
                 
                 : <div/>}
                 <Row style = {{width:'95%', marginLeft:'2%', marginTop:10}}>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                             
                         
                         let Last =Answer.List.slice(-1)[0]

                       
                         if(Answer.Left)
                         {
                             return 
                         }
                         if(!Answer.List.length){
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'+',
                             char:'+',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                             Special: false
                         })

                         Answer.Right = false
                         Answer.Left = true
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{+}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                        let Last = Answer.List.slice(-1)[0]

                         if(Answer.Left)
                         {

                             if(Answer.List.length && Answer.List.slice(-1)[0].char != '=' && Answer.List.slice(-1)[0].char == '-')
                             {
                                 return
                             } 
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'-',
                             char:'-',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                         })

                         Answer.Left = true
                         Answer.Right = false
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{-}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(Answer.Left)
                         {
                             return 
                         }

                         if(!Answer.List.length){
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'*',
                             char:'*',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket: Answer.LeftBracket,
                         })

                         Answer.Left = true
                         Answer.Right = false
                         Answer.RightBracket = true
                         Answer.LeftBracket = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer,
                            
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{*}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.RightBracket && Answer.List.length && Answer.List.slice(-1)[0].code != '(')
                         {
                             return 
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:'(',
                             char:'(',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket:  Answer.RightBracket,
                             LeftBracket:  Answer.LeftBracket,
                         })

                         Answer.echoNumber =
                         Answer.echoNumber + 1
                         
                         Answer.Left = true
                         Answer.Right = false
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer,
                            
                         })

                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{(}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#e6faff'
                     }}
                     className = "border border-secondary"
                     onClick = {() => {
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.LeftBracket  && Answer.List.length)
                         {
                             return 
                         }

                         if(Answer.echoNumber == 0)
                         {
                             return
                         }

                         Answer.List.push({
                             IsLatex:false,
                             code:')',
                             char:')',
                             Left: Answer.Left,
                             Right: Answer.Right,
                             RightBracket: Answer.RightBracket,
                             LeftBracket:Answer.LeftBracket,
                         })

                         Answer.echoNumber =
                         Answer.echoNumber - 1
                         
                         Answer.Left = false
                         Answer.Right = true
                         Answer.IsInteger = false

                         this.setState({
                             NewBoundryCondition:Answer
                         })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{)}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                         style = {{marginLeft:5, marginBottom:5,
                            flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                            backgroundColor:'#ffe6e6'
                        }}
                        className = "border border-secondary"
                        onClick = {() =>{
                            

                                                if(Answer.Left || !Answer.List.length){
                                                    return
                                                }

                                                Answer.List.push({
                                                    IsLatex:false,
                                                    code:'=',
                                                    char:'=',
                                                    Left: Answer.Left,
                                                    Right: Answer.Right,
                                                    RightBracket: Answer.RightBracket,
                                                    LeftBracket:Answer.LeftBracket,
                                                })

                                            
                                                Answer.Left = true
                                                Answer.Right = false
                                                Answer.IsInteger = false

                                                this.setState({
                                                    NewBoundryCondition:Answer
                                                })

                        }}
                        xs = {1}>
                            {<LatexViewComponent 
                                                height = {50}
                                                text = {'\\large{=}'}
                                                NoBorder = {true}
                                            />}
                        </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#ffe6e6'
                     }}
                     className = "border border-secondary"
                     onClick = {() =>{
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.List.length)
                                             {
                                                 return
                                             }

                                             Answer.Left = Last.Left
                                             Answer.LeftBracket = Last.LeftBracket
                                             Answer.Right = Last.Right
                                             Answer.RightBracket = Last.RightBracket
                                             Answer.IsInteger = Last.IsInteger

                                             let echoNumber = Answer.echoNumber

                                             if(Last.char == ')'){
                                                 echoNumber = echoNumber + 1
                                             }

                                             if(Last.char == '('){
                                                 echoNumber = echoNumber - 1
                                             }

                                             Answer.echoNumber = echoNumber

                                             Answer.List.pop()

                                             this.setState({
                                                 NewBoundryCondition:Answer
                                             })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'\\large{⇐}'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                     <Col
                      style = {{marginLeft:5, marginBottom:5,
                         flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center', cursor:'pointer',
                         backgroundColor:'#ffe6e6'
                     }}
                     className = "border border-secondary"
                     onClick = {() =>{
                         let Last = Answer.List.slice(-1)[0]

                         if(!Answer.List.length)
                                             {
                                                 return
                                             }

                                             Answer.echoNumber = 0

                                             Answer.List = []

                                             this.setState({
                                                 NewBoundryCondition:Answer
                                             })
                     }}
                     xs = {1}>
                         {<LatexViewComponent 
                                             height = {50}
                                             text = {'Clear'}
                                             NoBorder = {true}
                                         />}
                     </Col>
                 </Row>
                 <div style = {{height:3, borderBottom:1, borderColor:'#e6e6e6', borderBottomStyle:'solid',marginBottom:3, marginTop:5}}/>

                 </div >
                 <hr/>
                 <Row>
                     <Col xs = {10}>
                     </Col>
                     <Col xs = {1}>
                         <h5>
                             <Badge 
                             color = "primary" 
                             style = {{cursor:'pointer'}}
                             onClick = {() => {
                                if(!CheckKeyboardAnswer(Answer,true))
                                {
                                    alert("Please enter a valid answer!")
                                    return
                                }

                                let BoundryConditions = this.state.BoundryConditions
                                BoundryConditions[this.state.SelectedAnswerIndex] = Answer
                                this.setState({
                                    BoundryConditions:BoundryConditions,
                                    ShowEditBoundryCondition: false,
                                     NewBoundryCondition:{
                                         List:[]
                                     }
                                })
                             }}
                             > 
                             Update
                             </Badge>
                         </h5>
                     </Col>
                     <Col xs = {1}>
                         <h5>
                             <Badge 
                             color = "danger" 
                             style = {{cursor:'pointer'}}
                             onClick = {() => {
                                 this.setState({
                                     ShowEditBoundryCondition: false
                                 })
                             }}
                             > 
                             Close
                             </Badge>
                         </h5>
                     </Col>
                 </Row>

        </ModalComponent>
    )
}

   RelationsModal(){
       if(!this.state.ShowRelationModal){
           return
       }

       return(
           <ModalComponent NoActionLog = {true} isOpen = {this.state.ShowRelationModal} size = "xl">
            <Row style = {{width:'100%', marginBottom:5}}> 
                <Col xs = {11}>
                    <h5 style = {{color:'green'}}>
                        Choose a label from list below.
                    </h5>
                </Col>
                <Col xs = {1} style = {{flexDirection:'row', display:'flex', alignItems:'flex-end', alignContent:'flex-end'}}>
                    <h6 style = {{marginLeft:'100%'}}>
                        <Badge color = "danger" style = {{cursor:'pointer'}}
                            onClick = {() => {
                                this.setState({
                                    ShowRelationModal: false
                                })
                            }}
                        >
                            X
                        </Badge>
                    </h6>
                </Col>
            </Row>
            <Row style = {{width:'100%'}}>
            {this.state.Labels.filter((l) => !this.state.SelectedLabels.map((sl) => sl.Label.Id).includes(l.Id)).map((l,i) => (
                <Col 
                key = {i}
                style = {{width:'100%', cursor:'pointer', margin:5,
                 flexDirection:'row', alignContent:'center', alignItems:'center'}} onClick = {() => {
                     let SelectedLabels = this.state.SelectedLabels

                     //SelectedLabels = SelectedLabels.filter((l) => l.Direction != this.state.SelectedDirection)

                     let Relations = this.state.SelectedCV.Relations.filter((r) => 
                                      r.LabelId == l.Id 
                                  ).map((r) => r.EB_QuestionId)
                        
                        
                     let Questions = this.props.Question.Questions.filter((q) => Relations.includes(q.Id))
            

                    let New = ({
                        Label: l,
                        Direction: this.state.SelectedDirection,
                        Questions:Questions,
                        FlowType: this.state.SelectedDirection != CENTER ? INGOING_FLOW : SOURCE_FLOW,
                        Answers: [...Questions.map((q) => ({
                           List:[]
                        }))]
                    })

                    for(let i =0; i < Questions.length; i++){
                        let QuestionId = Questions[i].Id

                        let OtherLabel = this.state.SelectedLabels.filter((sl) => {
                            return sl.Questions.filter((q) => q.Id == QuestionId).length
                        })[0]

                        if(OtherLabel){
                            let OtherAnswer = OtherLabel.Answers.filter((a,i) => {

                                let QIndex = OtherLabel.Questions.map((q,ii) => ({
                                    Index: ii,
                                    Id:q.Id
                                })).filter((qq) => qq.Id == QuestionId)[0].Index
    
                                return(i == QIndex)
                            })[0]
    
                            New.Answers[i] = OtherAnswer
                        }

                        
                    }

                     SelectedLabels.push(New)

                    

                    this.setState({
                       SelectedLabels:SelectedLabels,
                       ShowRelationModal: false,
                    })
                }} className = "border border-secondary">
                        <SafeLatexViewComponent source = {l.Name}/>
                </Col>
            ))}
            </Row>
            
            
            </ModalComponent>
       )
   }

   

}

//Constant
//
const QUESTION_DATA_PARAMETER = 'Question'

const QUESTION_SEARCHING_PARAMETER = 'EBQUESTION_SEARCHING_PARAMETER'

const QUESTION_GET_ERROR_PARAMETER = 'EBQUESTION_GET_ERROR_PARAMETER'

function MapStateToProps(state) {
    return {

        IsQuestionSearching: state.Query[QUESTION_SEARCHING_PARAMETER],
        Question: state.Query[QUESTION_DATA_PARAMETER],
        GetQuestionError: state.Query[QUESTION_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,
        
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
         GetQuestion: (Id) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_SEARCHING_PARAMETER,
            DataParameter: QUESTION_DATA_PARAMETER,
            GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
            Path: Routes.GetEnergyBalanceQuestion,

            Value: Id,

            [QUESTION_SEARCHING_PARAMETER]: true,
            
            [QUESTION_DATA_PARAMETER]: {},
    
            [QUESTION_GET_ERROR_PARAMETER]: ''
        }))}
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(EnergyBalanceQuestionPlayComponent)